/* Affichely, fiche professionnelle : impression en quantité, tarif dégressif.

   Même parti pris que product.js et pele-mele.js : IIFE, pas de build, pas de dépendance.

   ⛔ LA REMISE PORTE SUR LE TOTAL DU PANIER, PAS SUR LA LIGNE. Elle est appliquée par
   des remises automatiques Shopify (5+, 10+, 25+, 50+, 100+, 250+) portant sur la
   collection « Affiches professionnelles » : c'est Shopify qui facture, pas cette page.
   Ici on ne fait qu'ANNONCER le prix que le panier appliquera. Les deux doivent donc
   dire la même chose, et la seule façon de le garantir est de calculer avec la même
   grille publiée, lue dans le métachamp `affiche.b2b_pricing`, avec la même formule et
   le même arrondi que `catalogue/b2b-tarifs.js`.

   ⛔ LA QUANTITE QUI OUVRE UN PALIER INCLUT CE QUI EST DEJA AU PANIER. Un client qui a
   déjà 40 affiches et en ajoute 15 passe le palier 50 : annoncer le tarif du palier 10
   parce que l'écran ne compte que ses 15 nouvelles affiches ferait mentir la page. Les
   lignes professionnelles se reconnaissent à leur propriété `_b2b`.

   ⛔ UNE QUANTITE ET UN FORMAT PAR LIGNE (Adrien, 04/08/2026). « Les pros ne vont pas
   acheter 50 affiches identiques depuis le catalogue, mais 1 ou 2 de chaque. » Un seul
   compteur pour toute la commande interdisait exactement le panier le plus courant :
   trente visuels différents en un exemplaire. Et un seul format interdisait le panier
   d'un hôtel : un visuel en 50x70 au-dessus du lit, deux en 30x40 dans le couloir, le
   MEME visuel dans deux formats. Chaque ligne porte donc sa quantité ET son format ;
   c'est la SOMME des quantités qui ouvre le palier, tous formats confondus.

   Rien n'est inventé côté client : sans grille publiée, la page le dit et n'affiche
   aucun prix plutôt que d'en fabriquer un. */
(function () {
  "use strict";

  var racine = document.querySelector("[data-b2b]");
  if (!racine) return;

  var CFG = window.B2B_CONFIG || {};
  var GRILLE = CFG.grille || null;
  var VARIANTES = CFG.variantes || {};
  /* ⛔ LE SUPPLEMENT D'URGENCE EST FACTURE PAR SHOPIFY, PAS ANNONCE PAR NOUS (14/08/2026).
     `supplements` porte les variantes du produit « Production acceleree », par delai puis par
     format : { "24h": { "50X70": { id, cents } , ... }, "48h": { ... } }. La page ne fait
     qu'additionner ces prix POUR LES MONTRER ; ce qui est preleve, c'est la ligne posee au
     panier. Un pourcentage calcule ici et absent du panier serait un prix affiche que la
     caisse dementirait, et c'est le genre d'ecart qu'on ne voit qu'au paiement.
     ⚠️ CES LIGNES NE COMPTENT PAS DANS LE PALIER : le produit n'est pas dans la collection
     « Affiches professionnelles », sur laquelle portent les six remises automatiques. Le
     supplement ne peut donc ni faire franchir un palier, ni etre remise lui-meme. */
  var SUPPLEMENTS = CFG.supplements || {};
  /* ⛔ SHOPIFY ECHAPPE LE HTML DE `| t`, ET C'EST MESURE, PAS SUPPOSE (Adrien, 20/08/2026 :
     « bug de balise »). Le filtre de traduction encode sa sortie sauf si la CLE se termine par
     `_html` : la page recevait donc `Encore &lt;b&gt;15 affiches&lt;/b&gt;` et
     `le supplement s&#39;ajoute`, l'un rendu en balise litterale par `innerHTML`, l'autre en
     entite litterale par `textContent`. Releve sur la page servie : les 62 cles arrivent
     encodees, y compris celles qui n'ont qu'une apostrophe.
     ⛔ ON DECODE ICI, UNE FOIS, POUR TOUTES LES CLES ET LES TREIZE LANGUES. Renommer les cles en
     `_html` aurait demande de toucher treize fichiers de locale et de se rappeler la convention
     a chaque cle ajoutee : une regle qu'il faut se rappeler est une regle qu'on oublie.
     ⚠️ LE DECODAGE PASSE PAR UNE `textarea`, ET C'EST LE POINT DELICAT : son `innerHTML` decode
     les entites SANS construire d'elements ni executer quoi que ce soit, et `.value` rend le
     texte. Un `div.innerHTML` aurait, lui, fabrique de vrais noeuds. */
  var T = (function (brut) {
    var out = {};
    var boite = document.createElement("textarea");
    for (var k in brut) {
      if (!Object.prototype.hasOwnProperty.call(brut, k)) continue;
      if (typeof brut[k] !== "string") { out[k] = brut[k]; continue; }
      boite.innerHTML = brut[k];
      out[k] = boite.value;
    }
    return out;
  })(CFG.t || {});
  /* ⛔ LA BARRE FINALE SE RETIRE. `routes.root_url` vaut « / » sur la langue principale :
     concatener « /cart.js » donnait « //cart.js », une adresse PROTOCOL-RELATIVE que le
     navigateur resout en « https://cart.js ». La lecture du panier et le selecteur
     d'affiches echouaient silencieusement. Meme regle que global.js et gallery-wall.js. */
  var RACINE_LOCALE = String(CFG.racine || "/").replace(/\/$/, "");

  function t(cle, repli) { return T[cle] || repli; }
  function urlPanier(chemin) { return RACINE_LOCALE + chemin; }
  function $(s, ctx) { return (ctx || racine).querySelector(s); }
  function $$(s, ctx) { return Array.prototype.slice.call((ctx || racine).querySelectorAll(s)); }

  /* ===== Prix : copie conforme de catalogue/b2b-tarifs.js ===== */

  /* Arrondi commercial, moitié vers le haut, sur la représentation décimale.
     Math.round(x * 100) rend 1,00 pour 1,005 : le binaire le stocke en dessous. */
  function arrondi2(x) {
    if (!isFinite(x)) return 0;
    var s = String(x);
    if (s.indexOf("e") >= 0 || s.indexOf("E") >= 0) return Math.round(x * 100) / 100;
    var negatif = s.charAt(0) === "-";
    if (negatif) s = s.slice(1);
    var point = s.indexOf(".");
    var entier = point < 0 ? s : s.slice(0, point);
    var decimal = point < 0 ? "" : s.slice(point + 1);
    while (decimal.length < 3) decimal += "0";
    var unites = parseInt(entier, 10) * 100 + parseInt(decimal.slice(0, 2), 10);
    if (decimal.charAt(2) >= "5") unites += 1;
    return (negatif ? -unites : unites) / 100;
  }

  var PALIERS = (GRILLE && GRILLE.paliers) || [1];

  function palier(qte) {
    var q = Math.max(1, Math.floor(qte) || 1);
    var atteint = PALIERS[0];
    for (var i = 0; i < PALIERS.length; i += 1) if (q >= PALIERS[i]) atteint = PALIERS[i];
    return atteint;
  }
  function palierSuivant(qte) {
    var q = Math.max(1, Math.floor(qte) || 1);
    for (var i = 0; i < PALIERS.length; i += 1) if (PALIERS[i] > q) return PALIERS[i];
    return null;
  }
  function remiseDe(p) { return (GRILLE && GRILLE.remise && GRILLE.remise[String(p)]) || 0; }
  function baseHT(format) { return (GRILLE && GRILLE.public_ht[format]) || 0; }
  /** Prix unitaire HT, format donné, à la quantité TOTALE du panier. */
  function unitaireHT(format, qteTotale) {
    if (!GRILLE) return 0;
    return arrondi2(baseHT(format) * (1 - remiseDe(palier(qteTotale))));
  }

  function euros(n) { return n.toFixed(2).replace(".", ",") + " " + (CFG.symbole || "€"); }
  function entier(n) {
    return Math.round(n).toLocaleString(CFG.locale || "fr-FR") + " " + (CFG.symbole || "€");
  }

  /* ===== Etat ===== */

  var compteur = 0;
  var etat = {
    cas: "fichier",
    /* Le delai courant de l'atelier, celui qui ne coute rien : les deux autres ajoutent une
       ligne de supplement au panier. */
    delai: "72h",
    marqueBlanche: false,
    nomBlanc: "",
    logo: "",
    /* L'onglet du tableau des tarifs. Distinct de `format` : consulter un prix ne doit pas
       changer ce qu'on achete, ni l'inverse. Initialise plus bas sur le format choisi. */
    formatGrille: "",
    /* ⛔ LE FORMAT DE DEPART DOIT EXISTER DANS LA GRILLE (12/08/2026). Le reglage disait
       « A2 » ; le jour ou la grille a ete ramenee aux quatre formats du B2C, une ligne neuve
       serait partie sur un format sans prix (baseHT rend 0) et sans variante : un panier a
       0,00 e. Un reglage perime ne doit jamais valoir mieux que la grille du jour. */
    format: (function () {
      var veut = CFG.format_defaut || "";
      var ids = (GRILLE && GRILLE.formats || []).map(function (f) { return f.id; });
      if (veut && ids.indexOf(veut) >= 0) return veut;
      return ids[0] || "";
    })(),
    /* { cle, type: 'fichier'|'catalogue', nom, url, apercu, handle, format, qte } */
    lignes: [],
    dejaPanier: 0,
    envoi: false
  };

  /* Quantité de départ d'une nouvelle ligne. Elle diffère selon le cas parce que les
     deux clientèles ne commandent pas pareil : un créateur qui dépose UN visuel en veut
     une série, un décorateur qui pioche dans le catalogue en veut un ou deux de chaque. */
  function qteDepart(type) {
    return type === "catalogue"
      ? (Number(CFG.qte_catalogue) || 1)
      : (Number(CFG.qte_fichier) || 10);
  }

  function lignesDu(type) {
    return etat.lignes.filter(function (l) { return l.type === type; });
  }
  function qteEcran() {
    return etat.lignes.reduce(function (s, l) { return s + Math.max(1, l.qte || 1); }, 0);
  }
  /** Quantité qui décide du palier : l'écran plus ce qui est déjà au panier. */
  function qteTotale() { return Math.max(1, etat.dejaPanier + qteEcran()); }

  /* ===== Elements ===== */

  var elPu = $("[data-b2b-pu]");
  var elBarre = $("[data-b2b-barre]");
  var elBadge = $("[data-b2b-badge]");
  var elPlancher = $("[data-b2b-plancher]");
  var elEconomie = $("[data-b2b-economie]");
  var elExpedition = $("[data-b2b-expedition]");
  /* ⛔ PAS elBarre : CE NOM EST DEJA PRIS PAR LE PRIX BARRE, quinze lignes plus haut.
     Le redeclarer ecrasait la meme liaison, et majPrix ecrivait le prix plein dans la
     barre mobile, dont il effacait le contenu au passage. */
  var elMobile = document.querySelector("[data-b2b-barre-mobile]");
  var elMobileTotal = elMobile && elMobile.querySelector("[data-b2b-barre-total]");
  var elMobileCta = elMobile && elMobile.querySelector("[data-b2b-barre-cta]");
  var elTotal = $("[data-b2b-total]");
  var elTotalTtc = $("[data-b2b-total-ttc]");
  var elTotalLib = $("[data-b2b-total-libelle]");
  var elTotalSup = $("[data-b2b-total-sup]");
  var elJauge = $("[data-b2b-jauge]");
  var elRelance = $("[data-b2b-relance]");
  var elAjouter = $("[data-b2b-ajouter]");
  var elEtat = $("[data-b2b-etat]");
  var elDepot = $("[data-b2b-depot]");
  var elInput = $("[data-b2b-input]");
  var elListeFichier = $("[data-b2b-liste='fichier']");
  var elListeCatalogue = $("[data-b2b-liste='catalogue']");

  /* Date d'expedition au plus tard, comptee en jours ouvres depuis aujourd'hui. Le
     framework demande un delai precis pres du bouton, pas une promesse en nombre de
     jours que le visiteur doit convertir lui-meme. Au-dela du plafond annonce, on ne
     donne pas de date : on dit ce qu'il se passe. */
  /**
   * ⛔ SEUL LE DIMANCHE NE COMPTE PAS (Adrien, 13/08/2026 : « ca fait 1 semaine de prod alors
   * qu'en realite c'est 72h ouvres max, seul le dimanche est exclu »). Cette fonction sautait
   * AUSSI le samedi : avec cinq jours au compteur, un client du jeudi lisait une date huit
   * jours plus loin. L'atelier travaille le samedi, la date le disait pourtant fermee.
   * ⚠️ LA MEME REGLE QUE LE STUDIO, qui calcule le delai d'expedition sans dimanche. Deux
   * calendriers pour un seul atelier finissent par annoncer deux dates a deux endroits.
   */
  /**
   * ⛔⛔ LA DATE ANNONCEE SUIT LE DELAI CHOISI, SINON ON FAIT PAYER UNE PRODUCTION PLUS RAPIDE
   * SANS JAMAIS ANNONCER UNE DATE PLUS PROCHE. Mesure du 21/08/2026 sur deux captures d'Adrien :
   * en 72 h comme en 48 h, la page annoncait « mardi 25 aout », alors que le supplement de
   * 21,83 € HT etait bien ajoute au total. L'acheteur payait donc 21,83 € pour voir la meme
   * date : c'est l'argument de vente de l'option qui disparaissait, et une promesse fausse dans
   * les deux sens (trop tard en 48 h et 24 h, juste par hasard en 72 h).
   * La cause tenait a une ligne : `Number(CFG.delai_jours) || 3` ignorait `etat.delai`.
   *
   * ⚠️ LE REGLAGE DE SECTION GARDE SON SENS, ET IL NE VAUT QUE POUR LE DELAI STANDARD. Les deux
   * options rapides portent leur duree dans leur nom : 48 h, c'est deux jours, 24 h un seul, et
   * les deriver d'un reglage prevu pour le troisieme les rendrait fausses le jour ou il change.
   */
  function joursDuDelai() {
    if (etat.delai === "24h") return 1;
    if (etat.delai === "48h") return 2;
    return Number(CFG.delai_jours) || 3;
  }

  function dateExpedition(joursOuvres) {
    var d = new Date();
    var restant = joursOuvres;
    while (restant > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) restant -= 1;
    }
    try {
      return d.toLocaleDateString(CFG.locale || "fr-FR", { weekday: "long", day: "numeric", month: "long" });
    } catch (e) {
      return d.toLocaleDateString();
    }
  }

  /* ⛔ ONZE FORMATS SANS AUCUN REPERE DE TAILLE. « 42 × 59,4 cm » ne dit rien a personne :
     le framework rappelle qu'une dimension en centimetres est abstraite tant qu'elle n'est
     pas comparee a un referentiel connu, et que la silhouette humaine est le referentiel
     des objets muraux. La fiche grand public a un guide des tailles, celle-ci l'avait
     perdu. Dessine ici plutot que photographie : la cote reste juste pour les onze
     formats, y compris si la grille en gagne un. */

  /* Barre collante sur mobile : la colonne d'achat fait plusieurs ecrans une fois les
     lignes posees, et le bouton disparait tout en haut. */
  function majBarre() {
    if (!elMobile) return;
    var n = qteEcran();
    elMobile.hidden = !etat.lignes.length;
    if (elMobileCta && elAjouter) elMobileCta.textContent = elAjouter.textContent;
    if (elMobileTotal && elTotal) {
      elMobileTotal.textContent = elTotal.textContent + " " + t("ht", "HT")
        + " · " + n + " " + (n > 1 ? t("affiches", "affiches") : t("affiche", "affiche"));
    }
  }

  /* ===== Rendu ===== */

  function majPrix() {
    if (!GRILLE) return;
    /* ⚠️ LA QUANTITE NE PASSE PAS PAR `majLignes`, elle passe par ici : les boutons + et − ne
       redessinent pas la liste, ils recalculent le prix. Sans cette seconde sauvegarde, un
       rechargement rendait douze visuels a une piece chacun. */
    sauverLignes();
    var qt = qteTotale();
    var p = palier(qt);
    var r = remiseDe(p);
    var ht = unitaireHT(etat.format, qt);
    var plein = unitaireHT(etat.format, 1);

    if (elPu) elPu.textContent = euros(ht);
    if (elBarre) { elBarre.hidden = !r; elBarre.textContent = euros(plein); }
    if (elBadge) { elBadge.hidden = !r; elBadge.textContent = "−" + Math.round(r * 100) + " %"; }
    /* ⛔ LE TOTAL SE CALCULE SUR LE PRIX NON ARRONDI, PAS SUR L'UNITAIRE AFFICHE.
       Shopify applique le pourcentage au total de la ligne : 250 A0 a -50 % font
       41,25 x 0,50 x 250 = 5 156,25 € HT. Multiplier l'unitaire arrondi (20,63) aurait
       annonce 5 157,50 €, soit un ecart avec le montant reellement facture. */
    var n = qteEcran();
    var brutHT = 0;
    var pleinHT = 0;
    /* ⛔ LE FORMAT SE CHANGE APRES LE RECADRAGE, ET IL CONTOURNAIT LE SEUL GARDE-FOU
       (14/08/2026). La fenetre de recadrage refuse un visuel trop petit pour SON format ;
       mais le selecteur de format de la ligne, lui, laissait passer un 21x30 valide bascule
       en 70x100, ou la meme zone ne fait plus qu'un tiers des points par centimetre. La
       commande partait, et c'est l'atelier qui decouvrait le fichier. On compte donc les
       lignes redevenues trop petites, et le bouton d'ajout les refuse. */
    var tropPetites = 0;
    etat.lignes.forEach(function (l) {
      var ligneHT = totalLigneHT(l, qt);
      brutHT += ligneHT;
      pleinHT += baseHT(l.format) * Math.max(1, l.qte || 1);
      if (l.elPrix) l.elPrix.textContent = entier(ligneHT) + " " + t("ht", "HT");
      if (l.elDef) {
        var d = definition(l.px, l.format);
        if (d && d.niveau === "mauvais") tropPetites += 1;
        if (!d) {
          l.elDef.textContent = l.px === null && l.type === "fichier"
            ? t("def_pdf", "PDF : la définition est vérifiée par nos soins avant impression.")
            : "";
          l.elDef.setAttribute("data-niveau", "inconnu");
        } else {
          /* Une pastille, un verdict, le chiffre entre parentheses. La phrase disait
             « 257 ppp : definition confortable pour ce format » : un acheteur qui ne sait
             pas ce qu'est un ppp devait lire jusqu'au bout pour savoir si c'etait bon. */
          l.elDef.textContent = "";
          var pastille = document.createElement("i");
          pastille.className = "b2b-pastille";
          pastille.setAttribute("aria-hidden", "true");
          l.elDef.appendChild(pastille);
          /* ⚠️ CE QUE DIT LA PASTILLE A CHANGE AVEC L'ECHELLE (14/08/2026) : « moyen » ne veut
             plus dire « juste », il veut dire « c'est notre agrandisseur qui portera le
             tirage ». Le libelle doit le dire, sinon le client lit une reserve la ou nous
             annonçons un service. */
          l.elDef.appendChild(document.createTextNode(t("def_" + d.niveau, {
            tresbon: "Qualité très bonne",
            bon: "Qualité bonne",
            moyen: "Agrandie en haute définition avant tirage",
            mauvais: "Trop petit pour ce format"
          }[d.niveau]) + " (" + d.ppp + " ppp)"));
          l.elDef.setAttribute("data-niveau", d.niveau);
        }
      }
    });
    /* Lu par `majBouton`, qui est appele juste apres partout ou les lignes bougent. */
    etat.tropPetites = tropPetites;
    majDelai();

    /* ⛔ ANCRE A L'ENVERS SANS CETTE LIGNE. Le premier prix qu'un visiteur voit est celui
       de la quantite 1, c'est-a-dire le PIRE, sur une page dont l'argument entier est la
       degressivite. Tant qu'aucune ligne n'est posee on annonce donc tout de suite ou
       descend le tarif ; des qu'il y en a, on annonce ce qu'il economise (cadrage de gain
       du framework, « 600 € economises » plutot que « le tarif baisse »). */
    var dernier = PALIERS[PALIERS.length - 1];
    if (elPlancher) {
      elPlancher.hidden = n > 0 || dernier === 1;
      if (!elPlancher.hidden) {
        /* Le prix du dernier palier ne se calcule plus ici : la ligne annonce l'existence
           du degressif et son seuil d'entree, pas son plafond, qui est deja dans les
           cartes de benefice et dans la grille. */
        elPlancher.textContent = t("plancher", "Tarif dégressif dès __N__ affiches")
          .replace("__N__", PALIERS.length > 1 ? PALIERS[1] : dernier);
      }
    }
    if (elExpedition) {
      var plafond = Number(CFG.delai_plafond) || 100;
      var jours = joursDuDelai();
      elExpedition.textContent = (etat.dejaPanier + n) > plafond
        ? t("expedition_gros", "Au-delà de __N__ affiches, la date de départ vous est confirmée après validation de vos fichiers.")
          .replace("__N__", plafond)
        : t("expedition", "Expédié au plus tard le __D__.").replace("__D__", dateExpedition(jours));
    }
    if (elEconomie) {
      var gain = pleinHT - brutHT;
      elEconomie.hidden = !(n > 0 && gain >= 1);
      if (!elEconomie.hidden) {
        elEconomie.textContent = t("economie", "Vous économisez __M__").replace("__M__", entier(gain));
      }
    }
    /* ⛔ LE TOTAL AFFICHE CONTIENT LE SUPPLEMENT D'URGENCE. Un total qui n'annonce que les
       affiches, suivi d'un panier plus cher, c'est la mauvaise surprise a la caisse : le
       supplement est une ligne a part dans le panier, pas un montant a part dans la tete de
       l'acheteur. Il n'entre pas dans `brutHT`, en revanche, parce que le gain degressif se
       calcule sur les affiches seules. */
    var supHT = supplementHT(etat.delai);
    if (elTotal) elTotal.textContent = n ? entier(brutHT + supHT) : "";
    if (elTotalTtc) {
      elTotalTtc.textContent = n
        ? t("soit_ttc", "soit __M__ TTC").replace("__M__", entier((brutHT + supHT) * (1 + GRILLE.tva)))
        : "";
    }
    if (elTotalSup) {
      elTotalSup.hidden = !(n && supHT > 0);
      if (!elTotalSup.hidden) {
        elTotalSup.textContent = t("total_sup", "dont production en __D__ : + __M__ HT")
          .replace("__D__", etat.delai === "24h" ? "24 h" : "48 h")
          .replace("__M__", euros(supHT));
      }
    }
    if (elTotalLib) {
      /* ⛔ LA QUANTITE EN GRAS DANS LE LIBELLE DU TOTAL (Adrien, serie 227). « Total HT » est
         la meme phrase sur toutes les pages du monde ; « 10 affiches » est le seul mot qui
         appartient a CETTE commande, et c'est celui qu'on relit pour verifier avant de payer.
         ⚠️ EN DEUX NOEUDS, JAMAIS EN innerHTML : le libelle vient d'un dictionnaire de
         reglages, et `n` d'un calcul. Composer du HTML ici ouvrirait une porte pour un gras. */
      elTotalLib.textContent = "";
      if (!n) { elTotalLib.textContent = t("total_vide", "Total HT"); }
      else {
        var gabarit = t("total_n", "Total HT · __N__ affiches");
        var bouts = gabarit.split("__N__");
        elTotalLib.appendChild(document.createTextNode(bouts[0] || ""));
        var fortN = document.createElement("b");
        fortN.textContent = n + " " + (n > 1 ? t("affiches", "affiches") : t("affiche", "affiche"));
        elTotalLib.appendChild(fortN);
        elTotalLib.appendChild(document.createTextNode(bouts[1] || ""));
      }
    }

    var suiv = palierSuivant(qt);
    if (suiv) {
      var manque = suiv - qt;
      var largeur = ((qt - p) / Math.max(1, suiv - p)) * 100;
      if (elJauge) elJauge.style.width = Math.max(0, Math.min(100, largeur)) + "%";
      if (elRelance) {
        elRelance.innerHTML = t("relance", "Encore <b>__N__</b> et le prix passe à __P__ l'unité HT.")
          .replace("__N__", manque + " " + (manque > 1 ? t("affiches", "affiches") : t("affiche", "affiche")))
          .replace("__P__", euros(unitaireHT(etat.format, suiv)));
      }
    } else {
      if (elJauge) elJauge.style.width = "100%";
      if (elRelance) elRelance.textContent = t("meilleur", "Meilleur tarif atteint.");
    }

    /* Le tableau dégressif suit le format choisi : un prix par palier, pour CE format.
       Onze colonnes de formats auraient été illisibles, et un acheteur regarde un format
       à la fois. Les cellules sont remplies ici, avec la même formule que l'entête. */
    $$("[data-b2b-ligne-palier]").forEach(function (tr) {
      var min = parseInt(tr.getAttribute("data-b2b-ligne-palier"), 10);
      var apres = palierSuivant(min);
      tr.setAttribute("aria-current", qt >= min && (apres === null || qt < apres) ? "true" : "false");
    });
    $$("[data-b2b-grille-ht]").forEach(function (td) {
      td.textContent = euros(unitaireHT(etat.formatGrille || etat.format, parseInt(td.getAttribute("data-b2b-grille-ht"), 10)));
    });
  }

  /* ===== Les onglets de format du tableau ==========================================
     ⛔ LE TABLEAU MONTRE UN FORMAT A LA FOIS, ET C'ETAIT LE FORMAT SELECTIONNE PLUS HAUT
     (Adrien, 13/08/2026 : « ajoute plutot des onglets a l'interieur du tableau de degressivite
     pour le tableau de prix pour chaque format »). Comparer le 30x40 au 70x100 obligeait donc a
     changer sa commande, puis a la remettre : on ne compare pas des prix en modifiant ce qu'on
     achete.
     ⚠️ LES ONGLETS ONT LEUR PROPRE ETAT, `etat.formatGrille`. Le lier a `etat.format` aurait
     reproduit le probleme dans l'autre sens : consulter un tarif aurait change la commande.
     ⚠️ AU PREMIER RENDU SEULEMENT, l'onglet suit le format choisi : c'est celui que le client
     regarde. Ensuite il vit sa vie. */
  function majOngletsGrille() {
    var rail = $("[data-b2b-grille-onglets]");
    if (!rail) return;
    var formats = (GRILLE && GRILLE.formats) || [];
    if (formats.length < 2) { rail.hidden = true; return; }
    if (rail.childElementCount === formats.length) {
      $$("[data-b2b-grille-onglet]", rail).forEach(function (b) {
        b.setAttribute("aria-selected",
          b.getAttribute("data-b2b-grille-onglet") === etat.formatGrille ? "true" : "false");
      });
      return;
    }
    rail.textContent = "";
    formats.forEach(function (f) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "sans";
      b.setAttribute("role", "tab");
      b.setAttribute("data-b2b-grille-onglet", f.id);
      b.setAttribute("aria-selected", f.id === etat.formatGrille ? "true" : "false");
      b.textContent = f.libelle;
      b.addEventListener("click", function () {
        etat.formatGrille = f.id;
        majOngletsGrille();
        /* Le tableau est repeint par `majPrix` : c'est elle qui remplit les cellules. */
        majPrix();
      });
      rail.appendChild(b);
    });
  }

  /** Libellé d'un format, pour le sélecteur de ligne. */
  function libelleFormat(id) {
    var l = id;
    ((GRILLE && GRILLE.formats) || []).forEach(function (f) { if (f.id === id) l = f.libelle; });
    return l;
  }

  /** Le total HT d'une ligne, au palier courant. */
  function totalLigneHT(l, qt) {
    return baseHT(l.format) * (1 - remiseDe(palier(qt))) * Math.max(1, l.qte || 1);
  }

  /**
   * Le sens du visuel : « paysage » ou « portrait ».
   * ⚠️ TROIS SOURCES, DANS L'ORDRE DE LEUR CERTITUDE : ce que le recadrage a decide, puis les
   * pixels mesures, puis le portrait par defaut — c'est le sens de toutes les affiches du
   * catalogue, dont le fichier source est au rapport 0,6923.
   */
  function orientationDe(l) {
    if (l.orientation === "paysage") return "paysage";
    if (l.orientation === "portrait") return "portrait";
    if (l.px && l.px.w && l.px.h) return l.px.w > l.px.h ? "paysage" : "portrait";
    return "portrait";
  }

  /** Une ligne de commande : vignette, nom, format, quantité, duplication, retrait. */
  function carteLigne(l) {
    var li = document.createElement("li");
    li.className = "b2b-ligne";

    if (l.apercu) {
      /* ⛔⛔ LA VIGNETTE PORTE L'ORIENTATION DU VISUEL, ET C'ETAIT FAUX (Adrien, 21/08/2026 :
         « la vignette d'un fichier paysage s'affiche a tort en portrait »). Sa boite etait
         44 x 60 pour tout le monde, et `object-fit:cover` recadrait donc une photo couchee dans
         un cadre debout : elle ne mentait pas un peu, elle mentait sur le SENS de l'affiche que
         l'acheteur est en train de commander, au moment ou il choisit son format.
         ⚠️ ET L'ORIENTATION SE DEDUIT DES PIXELS QUAND ELLE N'EST PAS POSEE. `coupe.orientation`
         n'existe que si le fichier a ete recadre ; un visuel deja au bon rapport n'en a pas, et
         une ligne du catalogue non plus. Les dimensions mesurees, elles, sont toujours la. */
      var vue = document.createElement("span");
      vue.className = "b2b-ligne__vue";
      vue.setAttribute("data-orient", orientationDe(l));
      var img = document.createElement("img");
      img.src = l.apercu;
      img.alt = "";
      img.loading = "lazy";
      vue.appendChild(img);
      li.appendChild(vue);
    }

    var corps = document.createElement("div");
    corps.className = "b2b-ligne__corps";

    var tete = document.createElement("div");
    tete.className = "b2b-ligne__tete";
    var nom = document.createElement("span");
    nom.className = "b2b-ligne__nom";
    nom.textContent = l.nom;
    /* ⛔ RIEN SOUS LE NOM D'UN FICHIER. « Votre fichier » sous « affiche-hall.pdf » ne dit
       rien que le nom ne dise deja. Seule une ligne du catalogue gagne un sous-titre : le
       titre d'une affiche ne dit pas d'ou elle vient. */
    if (l.type === "catalogue") {
      var sous = document.createElement("small");
      sous.textContent = t("du_catalogue", "Du catalogue");
      nom.appendChild(sous);
    }
    if (l.type === "fichier") {
      var def = document.createElement("small");
      def.className = "b2b-ligne__def";
      l.elDef = def;
      nom.appendChild(def);
    }
    var x = document.createElement("button");
    x.type = "button";
    x.className = "b2b-ligne__x";
    x.setAttribute("aria-label", t("retirer", "Retirer"));
    /* Le meme trace que la poubelle du panier (global.js), au pixel pres : une croix et une
       poubelle pour un meme geste dans deux ecrans qui se suivent, ca se remarque. */
    x.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"'
      + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>'
      + '<path d="M7 7l1 13h8l1-13"/><path d="M10 11v6M14 11v6"/></svg>';
    x.addEventListener("click", function () {
      etat.lignes = etat.lignes.filter(function (o) { return o.cle !== l.cle; });
      majLignes();
      majPrix();
      majBouton();
    });
    tete.appendChild(nom);
    tete.appendChild(x);
    corps.appendChild(tete);

    var bas = document.createElement("div");
    bas.className = "b2b-ligne__bas";

    /* Le format se choisit LIGNE PAR LIGNE : le même visuel peut partir en 50x70
       au-dessus d'un lit et en 30x40 dans le couloir. */
    var sel = document.createElement("select");
    sel.className = "b2b-ligne__fmt sans";
    sel.setAttribute("aria-label", t("format_ligne", "Format de cette affiche"));
    ((GRILLE && GRILLE.formats) || []).forEach(function (f) {
      var o = document.createElement("option");
      o.value = f.id;
      o.textContent = f.libelle;
      if (f.id === l.format) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener("change", function () {
      var avantFormat = l.format;
      l.format = sel.value;
      majLignes();
      majPrix();
      majBouton();
      reformater(l, avantFormat);
    });
    bas.appendChild(sel);

    var st = document.createElement("div");
    st.className = "b2b-ligne__qte";
    var moins = document.createElement("button");
    moins.type = "button";
    moins.setAttribute("aria-label", t("moins", "Retirer un exemplaire"));
    moins.textContent = "−";
    var champ = document.createElement("input");
    champ.type = "number";
    champ.min = "1";
    champ.max = "9999";
    champ.inputMode = "numeric";
    champ.className = "sans";
    champ.value = l.qte;
    champ.setAttribute("aria-label", t("exemplaires", "Nombre d'exemplaires"));
    var plus = document.createElement("button");
    plus.type = "button";
    plus.setAttribute("aria-label", t("plus", "Ajouter un exemplaire"));
    plus.textContent = "+";
    var poser = function (v) {
      l.qte = Math.max(1, Math.min(9999, Math.floor(v) || 1));
      champ.value = l.qte;
      majLignes();
      majPrix();
      majBouton();
    };
    moins.addEventListener("click", function () { poser(l.qte - 1); });
    plus.addEventListener("click", function () { poser(l.qte + 1); });
    champ.addEventListener("input", function () {
      l.qte = Math.max(1, Math.min(9999, parseInt(champ.value, 10) || 1));
      majPrix();
      majBouton();
    });
    st.appendChild(moins);
    st.appendChild(champ);
    st.appendChild(plus);
    bas.appendChild(st);

    /* Dupliquer : c'est la réponse à « le même visuel dans deux formats ». Le
       sélecteur du catalogue est une bascule, il ne peut pas choisir deux fois
       la même affiche. */
    var dup = document.createElement("button");
    dup.type = "button";
    dup.className = "b2b-ligne__dup sans";
    dup.textContent = t("autre_format", "+ un autre format");
    dup.addEventListener("click", function () {
      compteur += 1;
      var copie = {
        cle: l.cle.charAt(0) + compteur,
        type: l.type,
        nom: l.nom,
        url: l.url,
        apercu: l.apercu,
        handle: l.handle,
        produitId: l.produitId,
        format: l.format,
        qte: l.qte
      };
      copie.px = l.px;
      /* ⛔ `src` ET `orientation` VOYAGENT AVEC LA COPIE (audit du 14/08/2026). La copie
         sert a decliner LE MEME visuel dans un autre format, et deux formats n'ont pas le
         meme rapport : `reformater` doit alors recouper depuis le fichier d'origine. Sans
         `src`, il sort en silence (`!l.src`) et la copie vend l'ancienne coupe sous le
         nouveau rapport, precisement ce que son garde-fou interdit. Et sans `orientation`,
         une copie paysage repartait dans une page portrait, la faute de la serie 219 par
         une autre porte. `src` est une poignee vers le disque, pas 30 Mo en memoire. */
      copie.src = l.src;
      copie.orientation = l.orientation;
      /* elPrix et elDef ne sont pas recopies : la copie recevra les siens a la construction. */
      var i = etat.lignes.indexOf(l);
      etat.lignes.splice(i + 1, 0, copie);
      majLignes();
      majPrix();
      majBouton();
    });
    bas.appendChild(dup);

    /* ⛔ LE PRIX DE LIGNE SE RELIT DANS majPrix, PAS SEULEMENT ICI. Taper une quantité
       ne reconstruit pas la carte (cela ferait perdre le curseur du champ) : sans cette
       référence, la ligne restait affichée au prix d'un exemplaire pendant que le total,
       lui, était juste. */
    var prix = document.createElement("span");
    prix.className = "b2b-ligne__prix sans";
    l.elPrix = prix;
    bas.appendChild(prix);

    corps.appendChild(bas);
    li.appendChild(corps);
    return li;
  }

  function majLignes() {
    [["fichier", elListeFichier], ["catalogue", elListeCatalogue]].forEach(function (paire) {
      var liste = paire[1];
      if (!liste) return;
      liste.innerHTML = "";
      lignesDu(paire[0]).forEach(function (l) { liste.appendChild(carteLigne(l)); });
      if (paire[0] === "fichier" && lignesDu("fichier").length) {
        var plus = document.createElement("button");
        plus.type = "button";
        plus.className = "b2b-ligne__ajout sans";
        plus.textContent = t("autre_fichier", "+ Ajouter un autre visuel");
        plus.addEventListener("click", function () { if (elInput) elInput.click(); });
        liste.appendChild(plus);
      }
    });
    if (elDepot) elDepot.hidden = lignesDu("fichier").length > 0;
    /* ⛔ LA SAUVEGARDE SE FAIT ICI, ET NULLE PART AILLEURS. `majLignes` est le seul passage
       obligé de tout ce qui touche aux lignes : un depot, une suppression, une copie, un
       changement de format, une selection dans le catalogue. La poser sur chaque geste aurait
       demande de s'en souvenir a chaque geste ajoute, et c'est celui-la qu'on oublie. */
    sauverLignes();
  }

  /* ⛔ LE BOUTON PRINCIPAL N'EST JAMAIS DESACTIVE. Il l'etait a l'arrivee, avec une
     consigne pour libelle : le premier bouton de la page etait un cul-de-sac. Tant qu'il
     manque un visuel, il ouvre ce qui manque (le disque, ou le selecteur d'affiches) au
     lieu de refuser le clic. Loi de Fitts : une cible cliquable qui rapproche du but. */
  /* ===== Delai de production =====
     ⛔ LE SUPPLEMENT SE COMPTE PAR FORMAT, PAS AU FORFAIT (decision d'Adrien, QCM du
     14/08/2026 : « pourcentage du prix de l'affiche »). Un 70x100 en urgence occupe la
     machine trois fois plus longtemps qu'un 21x30 : un forfait unique ferait payer le petit
     format pour le grand. Chaque format a donc sa variante de supplement, et la quantite de
     la ligne suit celle des affiches de ce format. */
  function supplementCents(delai) {
    var table = SUPPLEMENTS[delai];
    if (!table) return 0;
    var total = 0;
    etat.lignes.forEach(function (l) {
      var v = table[l.format];
      if (v) total += (Number(v.cents) || 0) * Math.max(1, l.qte || 1);
    });
    return total;
  }

  /* ⛔ LES VARIANTES SONT TARIFEES TTC, LA PAGE PARLE HT. Shopify stocke un prix taxe
     comprise (`taxes_incluses: true` dans la grille) : afficher ces centimes tels quels
     mettrait un « + 10,37 € » TTC a cote d'un total HT, et le client additionnerait deux
     unites differentes. On repasse donc en HT pour l'ecran ; le panier, lui, facturera bien
     le prix TTC de la variante. */
  function supplementHT(delai) {
    var tva = GRILLE ? Number(GRILLE.tva) || 0 : 0;
    return supplementCents(delai) / 100 / (1 + tva);
  }

  function majDelai() {
    var bloc = $("[data-b2b-delai-bloc]");
    if (!bloc) return;
    /* Sans ligne, un supplement n'a rien a majorer : on annonce le principe, pas un zero. */
    var desLignes = etat.lignes.length > 0;
    $$("[data-b2b-delai]", bloc).forEach(function (b) {
      var d = b.getAttribute("data-b2b-delai");
      var actif = d === etat.delai;
      b.setAttribute("aria-pressed", String(actif));
      b.classList.toggle("est-actif", actif);
      var sup = b.querySelector("[data-b2b-delai-sup]");
      if (!sup) return;
      if (d === "72h") { sup.textContent = t("delai_inclus", "Inclus"); return; }
      if (!SUPPLEMENTS[d]) { sup.textContent = ""; b.disabled = true; return; }
      var c = supplementHT(d);
      sup.textContent = desLignes && c > 0
        ? "+ " + euros(c)
        : (d === "24h" ? t("delai_24_taux", "+ 20 %") : t("delai_48_taux", "+ 10 %"));
    });
    /* ⛔ PLUS DE NOTE SOUS LES BOUTONS : elle repetait ce qu'ils disent, et la relance a pris sa
       place (Adrien, 21/08/2026). Les trois cles `delai_note_*` restent dans les treize fichiers
       de langue, non utilisees : elles ne coutent rien et se rebranchent d'une ligne, la ou les
       retirer des treize demanderait un aller-retour pour rien. */
  }

  function majBouton() {
    if (!elAjouter) return;
    elAjouter.disabled = !GRILLE || etat.envoi;
    if (etat.envoi) {
      elAjouter.textContent = t("envoi", "Ajout en cours...");
    } else if (!etat.lignes.length) {
      elAjouter.textContent = etat.cas === "catalogue"
        ? t("cta_catalogue", "Choisir des affiches dans le catalogue")
        : t("cta_fichier", "Déposer mes fichiers");
    } else if (etat.tropPetites) {
      /* Le bouton DIT pourquoi il refuse : « Ajouter » grise sans un mot ferait chercher
         la panne du cote du site, alors que le geste a faire est sur la ligne, juste
         au-dessus, ou la pastille rouge nomme deja le format en cause. */
      elAjouter.disabled = true;
      elAjouter.textContent = etat.tropPetites > 1
        ? t("cta_petits", "__N__ visuels sont trop petits pour leur format").replace("__N__", etat.tropPetites)
        : t("cta_petit", "Un visuel est trop petit pour son format");
    } else {
      var nb = qteEcran();
      elAjouter.textContent = (nb > 1 ? t("cta_n", "Ajouter __N__ affiches au panier")
        : t("cta_1", "Ajouter cette affiche au panier")).replace("__N__", nb);
    }
    /* Le rappel du bloc format ne sert a rien tant qu'il n'y a rien a formater :
       onze boutons en deux familles avant le moindre engagement, c'est la loi de Hick
       appliquee a l'envers. Ils apparaissent avec la premiere ligne. */
    $$("[data-b2b-apres-ligne]").forEach(function (e) { e.hidden = !etat.lignes.length; });
    majBarre();
  }

  /* ===== Ce qui est déjà au panier ===== */

  function relirePanier() {
    if (!window.fetch) return Promise.resolve();
    return fetch(urlPanier("/cart.js"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var n = 0;
        (panier.items || []).forEach(function (i) {
          if (i.properties && i.properties._b2b) n += i.quantity || 0;
        });
        etat.dejaPanier = n;
        var note = $("[data-b2b-deja]");
        if (note) {
          note.hidden = !n;
          note.textContent = t("deja_panier", "__N__ affiches professionnelles déjà au panier, comptées dans la remise")
            .replace("__N__", n);
        }
        majPrix();
      })
      .catch(function () {});
  }

  /* ===== Dépôt des fichiers ===== */

  var TYPES_OK = { "image/jpeg": 1, "image/png": 1, "application/pdf": 1 };
  var MAX_OCTETS = 30 * 1024 * 1024;

  /* ⛔ LA PAGE PROMET DE PREVENIR SI LA DEFINITION EST TROP JUSTE. Elle le promettait sans
     rien mesurer : un professionnel pouvait deposer du 72 ppp pour un A0 sans le moindre
     signal, et decouvrir le probleme par un e-mail deux jours plus tard. Le parcours grand
     public affiche deja une pastille de definition ; celui-ci n'avait rien.

     Les pixels se lisent dans le navigateur pour les images. Un PDF ne se mesure pas ici :
     on le dit plutot que de laisser croire a un controle qui n'a pas eu lieu. */
  function mesurerImage(fichier) {
    return new Promise(function (res) {
      if (fichier.type !== "image/jpeg" && fichier.type !== "image/png") return res(null);
      var url = URL.createObjectURL(fichier);
      var img = new Image();
      img.onload = function () {
        var px = { w: img.naturalWidth || img.width, h: img.naturalHeight || img.height };
        URL.revokeObjectURL(url);
        res(px.w && px.h ? px : null);
      };
      img.onerror = function () { URL.revokeObjectURL(url); res(null); };
      img.src = url;
    });
  }

  /* Definition rendue au format demande. On compare le plus grand cote de l'image au plus
     grand cote du papier : c'est ainsi que le fichier sera pose. */
  function definition(px, format) {
    if (!px) return null;
    var fmt = null;
    ((GRILLE && GRILLE.formats) || []).forEach(function (f) { if (f.id === format) fmt = f; });
    if (!fmt) return null;
    var cmLong = Math.max(fmt.cm[0], fmt.cm[1]);
    var pxLong = Math.max(px.w, px.h);
    var ppp = Math.round(pxLong / (cmLong / 2.54));
    /* ⛔ LES PALIERS VIVENT DANS L'OUTIL DE RECADRAGE, PAS ICI (14/08/2026). Ils etaient
       recopies dans les deux fichiers : la fenetre pouvait refuser un fichier que la pastille
       de la ligne annonçait « moyen », pour le meme visuel, au meme format. Une seule echelle,
       et c'est celle qui decide du refus qui fait foi.
       ⚠️ SANS L'OUTIL, AUCUN NIVEAU : le depot est deja refuse dans ce cas (voir `recadrer`),
       et inventer un second bareme ici recreerait exactement la divergence qu'on ferme. */
    if (!window.B2BRecadrage || !window.B2BRecadrage.qualite) return null;
    return { ppp: ppp, niveau: window.B2BRecadrage.qualite(ppp).niveau };
  }

  /* ⛔ LE RECADRAGE EST OBLIGATOIRE SUR LES IMAGES (Adrien, serie 210 : « sinon ca ne sera
     pas accepte par l'atelier »). Le depot envoyait le fichier BRUT : une image 16/9 partait
     telle quelle vers un papier 50 x 70, et c'est l'atelier qui devait choisir ce qu'on coupe,
     ou refuser. Le rapport du cadre est celui du format CHOISI, dans le sens choisi : un
     50 x 70 couche est un 70 x 50, pas un rapport libre.

     ⚠️ UN PDF NE PASSE PAS PAR LA. Le navigateur ne sait pas le rasteriser sans bibliotheque
     tierce ; on le laisse filer plutot que d'ouvrir une fenetre qui ne saurait rien montrer.
     Le message le dit, au lieu de laisser croire a un controle qui n'a pas eu lieu.

     Rend : `null` (rien a recadrer), `ANNULE` (le client a ferme), `REFUSE` (depot refuse,
     message deja affiche), ou le resultat. */
  var ANNULE = { annule: true };
  /* ⛔ REFUSE N'EST PAS ANNULE (audit du 14/08/2026). ANNULE est un choix du client : le depot
     s'arrete SANS message, c'est lui qui a ferme. REFUSE est une panne de l'outil : le depot
     s'arrete AVEC un message qui reste affiche. Les confondre effacerait l'explication au
     moment exact ou le client en a besoin. */
  var REFUSE = { refuse: true };

  function formatDe(id) {
    var fmt = null;
    ((GRILLE && GRILLE.formats) || []).forEach(function (x) { if (x.id === id) fmt = x; });
    return fmt;
  }

  /* ⛔⛔ LE RECADRAGE FIGE LE RAPPORT D'IMPRESSION, PAS CELUI DU PAPIER (Adrien, 14/08/2026 :
     « le ratio d'impression B2B est le meme que B2C pour le moment »).
     CE QUE J'AVAIS FAIT, ET POURQUOI C'ETAIT FAUX : la premiere version coupait au rapport du
     PAPIER (0,700 pour un 21x30, 0,750 pour un 30x40, 0,7143 pour un 50x70). Or l'atelier
     n'imprime pas au rapport du papier : toute la boutique compose au 0,6923 de la zone
     imprimee, marges blanches comprises : c'est ce que fait la page personnalisee depuis
     toujours (`PERSO_RATIO_IMPRESSION` dans product.js) et ce que le catalogue impose a ses
     originaux. Un depot B2B coupe au rapport du papier arrivait donc a la presse dans un
     rapport que la chaine refuse, et j'ai propage la faute jusqu'a elargir sa garde.
     UNE SEULE VALEUR POUR TOUTE LA BOUTIQUE, ecrite ici comme dans product.js et pele-mele.js.
     ⚠️ CONSEQUENCE VOULUE : tous les formats partagent desormais le meme rapport, donc changer
     de format ne perime plus le recadrage : `reformater` sort de lui-meme. La fonction reste,
     elle redeviendra utile le jour ou un format aura son propre rapport. */
  var RATIO_IMPRESSION = 0.6923;

  function rapportDe(id) {
    return formatDe(id) ? RATIO_IMPRESSION : null;
  }

  function recadrer(fichier, format) {
    /* ⛔ MODULE ABSENT ≠ FICHIER NON RECADRABLE (audit du 14/08/2026). `b2b-recadrage.js` est
       charge en defer AVANT ce script : s'il manque au moment du depot, c'est que son
       chargement a ECHOUE (reseau, blocage). L'ancienne condition confondait les deux cas et
       rendait `null`, « rien a recadrer » : une IMAGE partait BRUTE a l'atelier, exactement le
       fichier au mauvais rapport que l'outil existe pour empecher, sans un mot pour le dire.
       Le PDF, lui, ne passe JAMAIS par la fenetre : module present ou pas, il file avec son
       message, c'est l'exception voulue. */
    if (!window.B2BRecadrage) {
      if (fichier.type === "application/pdf") {
        if (elEtat) elEtat.textContent = t("depot_pdf", "PDF reçu tel quel : vérifiez qu'il est déjà au format commandé.");
        return Promise.resolve(null);
      }
      if (elEtat) elEtat.textContent = t("recadrage_absent", "L'outil de recadrage n'a pas pu se charger. Rechargez la page, puis déposez votre visuel à nouveau.");
      return Promise.resolve(REFUSE);
    }
    if (!window.B2BRecadrage.disponible(fichier)) {
      if (fichier.type === "application/pdf" && elEtat) {
        elEtat.textContent = t("depot_pdf", "PDF reçu tel quel : vérifiez qu'il est déjà au format commandé.");
      }
      return Promise.resolve(null);
    }
    var fmt = formatDe(format);
    if (!fmt) return Promise.resolve(null);
    /* `cm` sert la DEFINITION (des pouces reels sous les pixels retenus), `rapport` sert la
       COUPE. Les deux ne se deduisent plus l'un de l'autre depuis qu'on coupe au rapport
       d'impression : le papier dit la taille, l'atelier dit la proportion. */
    return window.B2BRecadrage.ouvrir(fichier, {
      cm: fmt.cm, libelle: fmt.libelle, rapport: RATIO_IMPRESSION,
    }).then(function (r) { return r || ANNULE; });
  }

  /* ⛔ `usage=b2b` : CE VISUEL VA DANS SON PROPRE DOSSIER (Adrien, 07/08/2026). Le depot
     servait trois usages et les rangeait tous ensemble, sous le meme nommage en hash : on ne
     pouvait pas savoir, devant un fichier, s'il venait d'un particulier, d'un professionnel,
     ou de la photo d'un salon. Le parametre est ce qui permet au serveur de le ranger dans
     `perso_b2b/` et de le nommer `b2b_`. */
  function envoyer(corps, type, format) {
    /* `fmt` porte le format commande : le serveur controle le RAPPORT d'un PDF au depot
       (decision du 14/08/2026), puisque le PDF est le seul fichier qui echappe au recadrage
       oblige du navigateur. */
    var url = CFG.upload + (CFG.upload.indexOf("?") < 0 ? "?" : "&") + "usage=b2b";
    if (format) url += "&fmt=" + encodeURIComponent(format);
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": type },
      body: corps,
      mode: "cors",
      credentials: "omit"
    }).then(function (r) {
      if (r.ok) return r.json();
      /* ⛔ LE MOTIF DU SERVEUR VAUT MIEUX QUE « reessayez ». Un refus 422 porte un message
         qui dit QUOI corriger (rapport du PDF, fichier illisible) : l'avaler en `null`
         montrerait une erreur generique au moment exact ou le client peut agir. */
      return r.json().then(function (j) {
        return { erreur: (j && j.message) || null };
      }).catch(function () { return null; });
    });
  }

  /* ⛔ CHANGER DE FORMAT PERIME LE RECADRAGE. Le format se choisit LIGNE PAR LIGNE, et apres
     le depot : un visuel coupe pour un 30 x 40 (0,750) bascule sans rien dire vers un
     70 x 100 (0,700), et c'est encore l'atelier qui doit trancher ce qu'on rogne. La fenetre
     se rouvre donc sur le FICHIER D'ORIGINE, jamais sur la version deja coupee : recouper une
     coupe perdrait les pixels du premier passage sans jamais les rendre.

     ⚠️ `l.src` EST UNE POIGNEE, PAS UNE COPIE. Un objet `File` designe le fichier sur le
     disque ; le navigateur ne le lit qu'au moment ou on l'ouvre. Le garder sur la ligne ne
     retient donc pas 30 Mo par visuel en memoire.

     Refuser de recouper remet le format precedent : garder le nouveau reviendrait a vendre un
     rapport que le fichier ne tient pas. */
  function reformater(l, avant) {
    if (l.format === avant) return;
    if (rapportDe(l.format) === rapportDe(avant)) return;
    /* ⛔⛔ SANS LE FICHIER D'ORIGINE, ON REFUSE : ON NE SORT PLUS EN SILENCE. Une ligne relue
       apres un rechargement n'a plus sa poignee `src`, et l'adresse qu'elle porte designe la
       version DEJA COUPEE : recouper depuis elle perdrait les pixels du premier passage sans
       jamais les rendre. L'ancien `!l.src` rendait la main sans rien dire, donc la ligne gardait
       le nouveau format et vendait l'ancienne coupe sous un rapport qu'elle ne tient pas — le
       defaut exact que le garde-fou de cette fonction existe pour empecher. Il s'ouvrait deja
       sur les copies (audit du 14/08/2026) ; la persistance des lignes lui donnait une seconde
       porte, plus large.
       ⚠️ UN FORMAT DE MEME RAPPORT RESTE LIBRE : la sortie au-dessus le laisse passer, et c'est
       l'immense majorite des changements. */
    if (!l.src) {
      l.format = avant;
      if (elEtat) {
        elEtat.textContent = t("format_verrouille",
          "Redéposez ce visuel pour passer à un format d'une autre proportion.");
      }
      majLignes();
      majPrix();
      majBouton();
      return;
    }
    if (elEtat) elEtat.textContent = t("depot_envoi", "Envoi du fichier...");
    recadrer(l.src, l.format)
      .then(function (coupe) {
        if (!coupe || coupe === ANNULE || coupe === REFUSE) {
          l.format = avant;
          /* Le message de REFUSE reste affiche : effacer l'explication au moment du refus
             laisserait un selecteur qui revient en arriere sans dire pourquoi. */
          if (elEtat && coupe !== REFUSE) elEtat.textContent = "";
          majLignes();
          majPrix();
          majBouton();
          return null;
        }
        return envoyer(coupe.blob, coupe.type || l.src.type, l.format).then(function (j) {
          if (!j || !j.url) {
            l.format = avant;
            if (elEtat) elEtat.textContent = (j && j.erreur) || t("depot_ko", "Le dépôt a échoué, réessayez.");
          } else {
            l.url = j.url;
            l.apercu = j.preview || j.url;
            l.px = coupe.px;
            l.orientation = coupe.orientation;
            if (elEtat) elEtat.textContent = "";
          }
          majLignes();
          majPrix();
          majBouton();
        });
      })
      .catch(function () {
        l.format = avant;
        if (elEtat) elEtat.textContent = t("depot_ko", "Le dépôt a échoué, réessayez.");
        majLignes();
        majPrix();
        majBouton();
      });
  }

  function deposer(fichiers) {
    if (!CFG.upload) {
      if (elEtat) elEtat.textContent = t("depot_absent", "Le dépôt de fichiers est indisponible.");
      return;
    }
    var liste = Array.prototype.slice.call(fichiers || []);
    if (!liste.length) return;
    if (elEtat) elEtat.textContent = t("depot_envoi", "Envoi du fichier...");

    var suite = Promise.resolve();
    liste.forEach(function (f) {
      suite = suite.then(function () {
        if (!TYPES_OK[f.type]) {
          if (elEtat) elEtat.textContent = t("depot_type", "Formats acceptés : PDF, JPEG ou PNG.");
          return null;
        }
        if (f.size > MAX_OCTETS) {
          if (elEtat) elEtat.textContent = t("depot_lourd", "Fichier trop lourd : 30 Mo au maximum.");
          return null;
        }
        var px = null;
        var aEnvoyer = f;
        var orientation = null;
        var format = etat.format;
        return recadrer(f, format)
          .then(function (coupe) {
            /* ⛔ ANNULER LE RECADRAGE ANNULE LE DEPOT, ET SANS MESSAGE D'ECHEC. Envoyer quand
               meme le fichier brut rendrait le bouton « Annuler » mensonger, et l'atelier
               recevrait justement le fichier au mauvais rapport que l'outil existe pour
               empecher. `ANNULE` traverse toute la chaine jusqu'au bout : chaque maillon le
               laisse passer sans le confondre avec une panne de reseau. */
            if (coupe === ANNULE) return ANNULE;
            /* REFUSE s'arrete comme ANNULE, mais son message RESTE : c'est lui l'explication. */
            if (coupe === REFUSE) return REFUSE;
            if (coupe) { aEnvoyer = coupe.blob; orientation = coupe.orientation; px = coupe.px; }
            return coupe ? coupe.px : mesurerImage(f);
          })
          .then(function (mesure) {
            if (mesure === ANNULE) return ANNULE;
            if (mesure === REFUSE) return REFUSE;
            if (px === null) px = mesure;
            return envoyer(aEnvoyer, aEnvoyer.type || f.type, format);
          })
          .then(function (j) {
            if (j === REFUSE) return;
            if (j === ANNULE) { if (elEtat) elEtat.textContent = ""; return; }
            if (j && j.erreur) {
              if (elEtat) elEtat.textContent = j.erreur;
              return;
            }
            if (!j || !j.url) {
              if (elEtat) elEtat.textContent = t("depot_ko", "Le dépôt a échoué, réessayez.");
              return;
            }
            compteur += 1;
            b2bLog("fichier", format || "", null, { url: j.url });
            etat.lignes.push({
              cle: "f" + compteur,
              type: "fichier",
              nom: f.name || "visuel",
              url: j.url,
              apercu: j.preview || j.url,
              px: px,
              orientation: orientation,
              src: f,
              format: format,
              qte: qteDepart("fichier")
            });
            if (elEtat) elEtat.textContent = "";
            majLignes();
            majPrix();
            majBouton();
          })
          .catch(function () {
            if (elEtat) elEtat.textContent = t("depot_ko", "Le dépôt a échoué, réessayez.");
          });
      });
    });
  }

  /* ⛔ LES ECOUTEURS DU DELAI ET DE LA MARQUE BLANCHE VIVENT AU NIVEAU DU SCRIPT, jamais dans
     un peintre : la lecon du bouton « Recalculer » du Studio (13/08/2026), qui a ete signale
     trois fois pour trois causes differentes, dont celle-la. Ces deux blocs ne sont jamais
     redessines, un ecouteur pose une fois suffit. */
  $$("[data-b2b-delai]").forEach(function (b) {
    b.addEventListener("click", function () {
      etat.delai = b.getAttribute("data-b2b-delai") || "72h";
      majDelai();
      majPrix();
    });
  });

  var elBlanche = $("[data-b2b-blanche]");
  var elBlancheNom = $("[data-b2b-blanche-nom]");
  var elLogoBloc = $("[data-b2b-logo-bloc]");
  var elLogoInput = $("[data-b2b-logo-input]");
  var elLogoBtn = $("[data-b2b-logo-btn]");
  var elLogoVu = $("[data-b2b-logo-vu]");
  var elLogoX = $("[data-b2b-logo-x]");
  var elLogoEtat = $("[data-b2b-logo-etat]");

  function majLogo() {
    if (elLogoVu) { elLogoVu.hidden = !etat.logo; if (etat.logo) elLogoVu.src = etat.logo; }
    if (elLogoX) elLogoX.hidden = !etat.logo;
    if (elLogoBtn) elLogoBtn.hidden = !!etat.logo;
  }

  if (elBlanche) {
    elBlanche.addEventListener("change", function () {
      etat.marqueBlanche = !!elBlanche.checked;
      /* Le champ n'apparait qu'une fois l'option prise : un champ vide au-dessus d'une case
         decochee se lit comme une obligation, et il serait rempli pour rien. Le depot du
         logo suit la meme regle, et pour la meme raison. */
      if (elBlancheNom) {
        elBlancheNom.hidden = !etat.marqueBlanche;
        if (etat.marqueBlanche) elBlancheNom.focus();
        else { elBlancheNom.value = ""; etat.nomBlanc = ""; }
      }
      if (elLogoBloc) {
        elLogoBloc.hidden = !etat.marqueBlanche;
        /* ⛔ DECOCHER OUBLIE LE LOGO. Le garder en memoire le ferait repartir a la commande
           suivante sans que rien ne le montre : la case est decochee, le bloc est cache, et
           le bon sortirait pourtant a l'enseigne du revendeur. */
        if (!etat.marqueBlanche) { etat.logo = ""; majLogo(); if (elLogoEtat) elLogoEtat.textContent = ""; }
      }
    });
  }

  if (elLogoBtn && elLogoInput) {
    elLogoBtn.addEventListener("click", function () { elLogoInput.click(); });
  }
  if (elLogoX) {
    elLogoX.addEventListener("click", function () {
      etat.logo = "";
      if (elLogoInput) elLogoInput.value = "";
      if (elLogoEtat) elLogoEtat.textContent = "";
      majLogo();
    });
  }
  if (elLogoInput) {
    elLogoInput.addEventListener("change", function () {
      var f = elLogoInput.files && elLogoInput.files[0];
      if (!f) return;
      /* ⚠️ LE POIDS SE REFUSE ICI, PAS APRES L'ENVOI : un logo est un petit fichier, et un
         refus apres trente secondes de televersement se lit comme une panne. */
      if (f.size > 5 * 1024 * 1024) {
        if (elLogoEtat) elLogoEtat.textContent = t("logo_lourd", "Logo trop lourd : 5 Mo au maximum.");
        elLogoInput.value = "";
        return;
      }
      if (elLogoEtat) elLogoEtat.textContent = t("logo_envoi", "Envoi du logo...");
      /* Le meme depot que les visuels, avec `usage=logo` : le serveur le range dans la famille
         qui ne s'imprime jamais, et refuse tout ce qui n'est pas une image. */
      var url = CFG.upload + (CFG.upload.indexOf("?") < 0 ? "?" : "&") + "usage=logo";
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": f.type || "image/png" },
        body: f,
        mode: "cors",
        credentials: "omit"
      }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) { return { erreur: (j && j.message) || null }; })
          .catch(function () { return null; });
      }).then(function (rep) {
        elLogoInput.value = "";
        if (!rep || !rep.url) {
          if (elLogoEtat) {
            elLogoEtat.textContent = (rep && rep.erreur)
              || t("logo_ko", "Le dépôt du logo a échoué, réessayez.");
          }
          return;
        }
        etat.logo = rep.url;
        if (elLogoEtat) elLogoEtat.textContent = "";
        majLogo();
      }).catch(function () {
        elLogoInput.value = "";
        if (elLogoEtat) elLogoEtat.textContent = t("logo_ko", "Le dépôt du logo a échoué, réessayez.");
      });
    });
  }
  if (elBlancheNom) {
    elBlancheNom.addEventListener("input", function () {
      etat.nomBlanc = String(elBlancheNom.value || "").trim().slice(0, 60);
    });
  }

  if (elInput) {
    elInput.addEventListener("change", function () {
      deposer(elInput.files);
      elInput.value = "";
    });
  }
  if (elDepot) {
    elDepot.addEventListener("click", function () { if (elInput) elInput.click(); });
    ["dragenter", "dragover"].forEach(function (e) {
      elDepot.addEventListener(e, function (ev) {
        ev.preventDefault();
        elDepot.classList.add("is-over");
      });
    });
    ["dragleave", "drop"].forEach(function (e) {
      elDepot.addEventListener(e, function (ev) {
        ev.preventDefault();
        elDepot.classList.remove("is-over");
        if (e === "drop" && ev.dataTransfer) deposer(ev.dataTransfer.files);
      });
    });
  }

  /* ===== Sélecteur d'affiches du catalogue =====
     La liste vient de la vue `?view=picker` déjà servie pour le composeur mural : une
     seule vue JSON pour les deux outils, donc un seul endroit à corriger. */

  var picker = document.querySelector("[data-b2b-picker]");
  var pickerListe = picker && picker.querySelector("[data-b2b-picker-liste]");
  var pickerRecherche = picker && picker.querySelector("[data-b2b-picker-q]");
  var pickerCompte = picker && picker.querySelector("[data-b2b-picker-compte]");
  var pickerCache = {};
  var pickerSel = [];
  var pickerPage = 1;
  var pickerPages = 1;
  var pickerQ = "";
  var pickerPlus = picker && picker.querySelector("[data-b2b-picker-plus]");
  var pickerFacettes = picker && picker.querySelector("[data-b2b-picker-facettes]");
  /* Une page a la fois : sans ce verrou la sentinelle reste visible pendant le fetch et
     redeclenche a chaque intersection, ce qui demanderait les pages 2, 3 et 4 d'un coup. */
  var pickerEnCours = false;
  /* Facettes actives : { "filter.p.m.custom.piece": ["Salon", "Bureau"] }. On les rejoue
     telles quelles dans l'URL, ce sont les parametres de Search & Discovery, les memes
     qu'une page collection. Meme mecanique que gallery-wall.js, pour la meme raison. */
  var pickerFiltres = {};
  var pickerDispo = [];

  function pickerOuvrir() {
    if (!picker) return;
    pickerSel = lignesDu("catalogue").map(function (l) {
      return { handle: l.handle, title: l.nom, img: l.apercu, id: l.produitId };
    });
    picker.hidden = false;
    document.body.style.overflow = "hidden";
    pickerCharger("", 1);
  }
  function pickerFermer() {
    if (!picker) return;
    picker.hidden = true;
    document.body.style.overflow = "";
  }
  function pickerMajCompte() {
    if (!pickerCompte) return;
    pickerCompte.textContent = pickerSel.length
      ? t("picker_compte", "__N__ affiche(s) choisie(s)").replace("__N__", pickerSel.length)
      : t("picker_vide_sel", "Choisissez une ou plusieurs affiches. Vous réglerez la quantité de chacune ensuite.");
  }
  function chaineFacettes() {
    var q = "";
    Object.keys(pickerFiltres).forEach(function (p) {
      (pickerFiltres[p] || []).forEach(function (v) {
        q += "&" + encodeURIComponent(p) + "=" + encodeURIComponent(v);
      });
    });
    return q;
  }
  function facetteActive(param, valeur) {
    return (pickerFiltres[param] || []).indexOf(valeur) > -1;
  }
  function facetteBascule(param, valeur) {
    var l = pickerFiltres[param] || (pickerFiltres[param] = []);
    var i = l.indexOf(valeur);
    if (i > -1) l.splice(i, 1); else l.push(valeur);
    if (!l.length) delete pickerFiltres[param];
    pickerCharger(pickerQ, 1);
  }
  /* Les facettes du catalogue, en accordeons FERMES. La loi de Hick reproche a cette page
     son nombre de choix : six groupes ouverts en ajouteraient une cinquantaine d'un coup.
     Ferme, un groupe ne coute qu'une ligne, et le nombre d'actifs reste lisible. */
  function pickerPeindreFacettes() {
    if (!pickerFacettes) return;
    /* Une recherche par mot-cle sert /search, qui ne rend pas les facettes de la
       collection : les melanger produirait des filtres sans effet sur la liste. */
    if (pickerQ || !pickerDispo.length) {
      pickerFacettes.hidden = true;
      pickerFacettes.innerHTML = "";
      return;
    }
    pickerFacettes.hidden = false;
    pickerFacettes.innerHTML = "";
    var actifs = 0;
    Object.keys(pickerFiltres).forEach(function (p) { actifs += (pickerFiltres[p] || []).length; });

    pickerDispo.forEach(function (f) {
      if (!f || !f.values || !f.values.length) return;
      var d = document.createElement("details");
      d.className = "b2b-facette";
      var n = 0;
      f.values.forEach(function (v) { if (facetteActive(v.param || f.param, v.value)) n += 1; });
      var sm = document.createElement("summary");
      sm.className = "sans";
      sm.textContent = f.label + (n ? " (" + n + ")" : "");
      if (n) sm.setAttribute("data-on", "1");
      d.appendChild(sm);
      var corps = document.createElement("div");
      corps.className = "b2b-facette__corps";
      f.values.forEach(function (v) {
        var param = v.param || f.param;
        var lab = document.createElement("label");
        lab.className = "b2b-facette__opt sans";
        var c = document.createElement("input");
        c.type = "checkbox";
        c.checked = facetteActive(param, v.value);
        c.addEventListener("change", function () { facetteBascule(param, v.value); });
        lab.appendChild(c);
        if (f.couleur && v.swatch) {
          var pastille = document.createElement("span");
          pastille.className = "b2b-facette__chip";
          pastille.style.background = v.swatch;
          lab.appendChild(pastille);
        }
        var t2 = document.createElement("span");
        t2.textContent = v.label;
        lab.appendChild(t2);
        var cpt = document.createElement("i");
        cpt.textContent = v.n;
        lab.appendChild(cpt);
        corps.appendChild(lab);
      });
      /* ⛔ UN SEUL GROUPE OUVERT A LA FOIS. Les panneaux sont en position absolue : deux
         ouverts se chevauchaient, et les cases de celui de dessous devenaient
         incliquables. `toggle` plutot que `click` sur le summary : il part aussi quand
         le clavier ouvre le groupe. */
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        pickerFacettes.querySelectorAll("details.b2b-facette[open]").forEach(function (autre) {
          if (autre !== d) autre.open = false;
        });
      });
      d.appendChild(corps);
      pickerFacettes.appendChild(d);
    });

    if (actifs) {
      var raz = document.createElement("button");
      raz.type = "button";
      raz.className = "b2b-facette__raz sans";
      raz.textContent = t("picker_raz", "Tout effacer (__N__)").replace("__N__", actifs);
      raz.addEventListener("click", function () { pickerFiltres = {}; pickerCharger(pickerQ, 1); });
      pickerFacettes.appendChild(raz);
    }
  }

  /* ⛔ CINQUANTE AFFICHES SUR MILLE CINQ CENT SOIXANTE-DIX. La vue picker pagine par 50 et
     rend `page` et `pages` : sans bouton pour aller plus loin, un acheteur qui cherchait
     autre chose que les cinquante premieres n'avait que le champ de recherche, et rien ne
     lui disait qu'il manquait 97 % du catalogue. */
  function pickerCharger(q, page, ajouter) {
    if (!pickerListe) return;
    pickerQ = q || "";
    pickerPage = page || 1;
    var url = pickerQ
      ? RACINE_LOCALE + "/search?view=picker&v=1&type=product&page=" + pickerPage + "&q=" + encodeURIComponent(pickerQ)
      : RACINE_LOCALE + "/collections/" + (CFG.picker_collection || "catalogue-professionnel")
        + "?view=picker&v=2&page=" + pickerPage;
    url += chaineFacettes();
    /* ⛔ LE CACHE PORTE LES TROIS, PAS SEULEMENT LES PRODUITS. Il n'a longtemps garde que
       la liste : sur un retour en cache, `pickerPages` et `pickerDispo` restaient ceux du
       dernier appel reseau. Apres « Tout effacer », la page 1 revenait bien du cache mais
       annoncait « page 1 sur 4 » au lieu de 32, et les facettes gardaient les comptes du
       filtre qu'on venait de lever. Deux nombres faux a l'ecran, aucune erreur nulle part. */
    pickerEnCours = true;
    if (pickerCache[url]) {
      var c = pickerCache[url];
      pickerEnCours = false;
      pickerPages = c.pages;
      if (c.filters) pickerDispo = c.filters;
      return pickerPeindre(c.produits, ajouter);
    }
    /* Le message de chargement effacait la liste meme quand on ajoutait une page :
       « voir plus » rendait 50 affiches au lieu de 100. */
    if (!ajouter) {
      pickerListe.innerHTML = '<p class="b2b-picker__vide">' + t("picker_chargement", "Chargement...") + "</p>";
    } else if (pickerPlus) {
      pickerPlus.textContent = t("picker_chargement", "Chargement...");
    }
    /* ⛔ AUCUN EN-TETE Accept SUR CES ADRESSES. Shopify negocie le contenu sur les URL de
       collection et de recherche : avec `Accept: application/json` il rend SA
       representation de la collection ({"collection":{"id":…}}, sans produits) et ignore
       `view=picker`. Le selecteur restait vide sur « Liste indisponible ». gallery-wall.js
       porte deja la meme mise en garde, pour la meme raison. */
    fetch(url, { cache: "no-cache" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        pickerPages = Number(j.pages) || 1;
        /* Shopify recalcule les comptes a chaque appel selon les facettes deja posees :
           on prend ce qu'il rend plutot que de garder la premiere version, sinon les
           nombres entre parentheses mentent des le second filtre. */
        if (j.filters) { pickerDispo = j.filters; pickerPeindreFacettes(); }
        pickerCache[url] = { produits: j.products || [], pages: pickerPages, filters: j.filters || null };
        pickerEnCours = false;
        pickerPeindre(pickerCache[url].produits, ajouter);
      })
      .catch(function () {
        pickerEnCours = false;
        pickerListe.innerHTML = '<p class="b2b-picker__vide">' + t("picker_ko", "Liste indisponible.") + "</p>";
      });
  }
  function pickerPeindre(produits, ajouter) {
    if (!pickerListe) return;
    if (!ajouter) pickerListe.innerHTML = "";
    if (!produits.length && !ajouter) {
      pickerListe.innerHTML = '<p class="b2b-picker__vide">' + t("picker_rien", "Aucune affiche trouvée.") + "</p>";
      return;
    }
    produits.forEach(function (p) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "b2b-picker__item";
      var choisi = pickerSel.some(function (c) { return c.handle === p.handle; });
      b.setAttribute("aria-pressed", choisi ? "true" : "false");
      var img = document.createElement("img");
      img.src = p.img;
      img.alt = "";
      img.loading = "lazy";
      var s = document.createElement("span");
      s.textContent = p.title;
      b.appendChild(img);
      b.appendChild(s);
      b.addEventListener("click", function () {
        var i = -1;
        pickerSel.forEach(function (c, k) { if (c.handle === p.handle) i = k; });
        if (i >= 0) pickerSel.splice(i, 1);
        else pickerSel.push({ handle: p.handle, title: p.title, img: p.img, id: p.id });
        b.setAttribute("aria-pressed", i >= 0 ? "false" : "true");
        pickerMajCompte();
      });
      pickerListe.appendChild(b);
    });
    pickerPeindreFacettes();
    if (pickerPlus) {
      /* Le bouton ne s'affiche plus que si la liste ne defile pas (fenetre tres haute,
         derniere page courte) : sans defilement, pas de defilement infini. Il reste aussi
         le porteur du message de chargement. */
      pickerPlus.hidden = pickerPage >= pickerPages
        || pickerListe.scrollHeight > pickerListe.clientHeight + 8;
      pickerPlus.textContent = t("picker_plus", "Voir 50 affiches de plus (page __N__ sur __T__)")
        .replace("__N__", pickerPage).replace("__T__", pickerPages);
    }
    pickerMajCompte();
  }

  if (picker) {
    /* Defilement infini, sur l'evenement `scroll` de la liste.
       ⛔ PAS D'IntersectionObserver ICI. La premiere version en utilisait un, avec une
       sentinelle en dernier enfant. Deux pieges s'y cachent : `observe()` est sans effet
       tant que la cible n'est pas descendante du `root` (aucune erreur, aucun
       avertissement, simplement rien), et un observateur ne se declenche PAS dans un
       document masque, ce qui le rend invisible a toute verification automatisee. Un
       ecouteur de defilement n'a ni l'un ni l'autre defaut et se mesure.
       400 px d'avance : la page suivante part avant que le visiteur touche le bas, sinon
       il voit un blanc a chaque palier de cinquante. */
    if (pickerListe) {
      pickerListe.addEventListener("scroll", function () {
        if (pickerEnCours || pickerPage >= pickerPages) return;
        var reste = pickerListe.scrollHeight - pickerListe.scrollTop - pickerListe.clientHeight;
        if (reste < 400) pickerCharger(pickerQ, pickerPage + 1, true);
      }, { passive: true });
    }
    picker.addEventListener("click", function (e) { if (e.target === picker) pickerFermer(); });
    var x = picker.querySelector("[data-b2b-picker-fermer]");
    if (x) x.addEventListener("click", pickerFermer);
    var ok = picker.querySelector("[data-b2b-picker-valider]");
    if (ok) {
      ok.addEventListener("click", function () {
        /* ⛔ REVENIR DANS LE SELECTEUR NE DOIT RIEN EFFACER. Les lignes déjà posées
           gardent leur quantité ET leur format, y compris les DOUBLONS d'une même
           affiche déclinée en deux formats : le sélecteur est une bascule par affiche,
           il ne sait pas compter les déclinaisons. On conserve donc les lignes dont
           l'affiche reste cochée, et on n'ajoute que les affiches nouvelles. */
        var coche = {};
        pickerSel.forEach(function (c) { coche[c.handle] = c; });
        var gardees = lignesDu("catalogue").filter(function (l) { return coche[l.handle]; });
        var deja = {};
        gardees.forEach(function (l) { deja[l.handle] = true; });
        var ajoutees = [];
        pickerSel.forEach(function (c) {
          if (deja[c.handle]) return;
          compteur += 1;
          b2bLog("catalogue", c.handle || "");
          ajoutees.push({
            cle: "c" + compteur,
            type: "catalogue",
            nom: c.title,
            handle: c.handle,
            produitId: c.id,
            apercu: c.img,
            format: etat.format,
            qte: qteDepart("catalogue")
          });
        });
        etat.lignes = lignesDu("fichier").concat(gardees, ajoutees);
        pickerFermer();
        majLignes();
        majPrix();
        majBouton();
      });
    }
    if (pickerRecherche) {
      var minuteur = null;
      pickerRecherche.addEventListener("input", function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () { pickerCharger(pickerRecherche.value.trim(), 1); }, 280);
      });
    }
    if (pickerPlus) {
      pickerPlus.addEventListener("click", function () {
        pickerCharger(pickerQ, pickerPage + 1, true);
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !picker.hidden) pickerFermer();
    });
  }
  $$("[data-b2b-parcourir]").forEach(function (b) { b.addEventListener("click", pickerOuvrir); });

  /* ===== Commandes de l'écran ===== */

  function poserCas(nom) {
    etat.cas = nom;
    $$("[data-b2b-cas]").forEach(function (o) {
      o.setAttribute("aria-pressed", o.getAttribute("data-b2b-cas") === nom ? "true" : "false");
    });
    $$("[data-b2b-pan]").forEach(function (p) {
      p.hidden = p.getAttribute("data-b2b-pan") !== nom;
    });
    majPrix();
    majBouton();
  }
  $$("[data-b2b-cas]").forEach(function (b) {
    b.addEventListener("click", function () { poserCas(b.getAttribute("data-b2b-cas")); });
  });

  /* Les deux blocs « à qui on s'adresse » renvoient dans la bonne voie de la colonne
     d'achat : un lien qui ne fait que remonter la page laisserait le visiteur devant
     l'onglet qui ne le concerne pas. */
  $$("[data-b2b-voie]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      poserCas(b.getAttribute("data-b2b-voie"));
      var cible = $(".b2b-buy");
      if (cible) cible.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  /* ⛔ PLUS DE SELECTEUR DE FORMAT GLOBAL. Onze boutons posaient un format « pour toute la
     commande » alors que chaque ligne porte deja le sien : deux commandes pour un meme
     reglage, dont l'une ecrasait l'autre en silence. `etat.format` survit, mais seulement
     comme format de depart d'une nouvelle ligne, lu dans `format_defaut`. */

  /* ===== Ajout au panier =====
     Un visuel = une ligne, avec sa quantité. La remise n'est pas posée ici : Shopify
     l'applique au panier, sur la quantité totale de la collection professionnelle. */

  /* =========================================================================================
     LE FUNNEL B2B (Adrien, 20/08/2026 : « suivre visiteurs uniques de la page, import fichier,
     import catalogue, ajout au panier avec nombre d'unites, CA HT »).

     ⛔ MEME IDENTITE QUE LES QUATRE AUTRES FUNNELS : `af:vid`, un uuid tire au sort dans le
     navigateur, sans aucune donnee personnelle. Un pro qui a ouvert le composeur puis la page
     pro doit pouvoir se suivre d'un outil a l'autre ; deux identites l'auraient coupe en deux.

     ⛔ L'ACHAT NE PART PAS D'ICI. On pose l'attribut de panier `b2b_vid` ; le Studio lit les
     commandes qui le portent et calcule le chiffre d'affaires HT sur la COMMANDE. Un POST du
     navigateur ne doit jamais pouvoir fabriquer une vente : c'est la regle des quatre autres.
     ========================================================================================= */
  var B2B_LOG = "https://runway.dcomdtf.app/b2b-log";
  function b2bVid() {
    try {
      var v = localStorage.getItem("af:vid");
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("af:vid", v);
      }
      return v;
    } catch (e) { return ""; }
  }
  /* ⛔ LE TOTAL DU PANIER, PAS UNE COCHE (Adrien, 20/08/2026 : « panier HT, achat HT »). Le
     Studio savait qu'un panier avait suivi, jamais ce qu'il pesait. Le total se lit sur
     `/cart.js` APRES l'ajout, donc c'est le panier reel. Un echec ne bloque rien : sans montant,
     l'evenement part quand meme et le Studio ecrit un tiret plutot qu'un chiffre invente.
     ⚠️ AVEC LA RACINE DE LANGUE : `urlPanier` la porte deja dans cette fermeture, et une racine
     devinee sur l'adresse courante renverrait 404 sur douze marches. */
  function totalPanierB2B() {
    return fetch(urlPanier("/cart.js"), { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = Number(c && c.total_price);
        return isFinite(t) && t > 0 ? t / 100 : null;
      })
      .catch(function () { return null; });
  }
  function b2bLog(evenement, detail, unites, extra) {
    var v = b2bVid();
    if (!v) return;
    var charge = { vid: v, evenement: evenement, detail: String(detail || "").slice(0, 120) };
    if (unites != null) charge.unites = unites;
    /* Le fichier depose voyage avec l'evenement : le Studio doit pouvoir OUVRIR ce que le pro a
       envoye, pas seulement compter les depots. Le serveur n'accepte que nos propres adresses. */
    if (extra && extra.url) charge.url = String(extra.url).slice(0, 500);
    if (extra && extra.montant != null) charge.montant = extra.montant;
    /* ⚠️ `keepalive` : l'arrivee part au chargement, et une navigation immediate tuerait la
       requete sans lui. Les erreurs sont avalees : une balise qui casse la page qu'elle mesure
       coute plus que la mesure. */
    try {
      fetch(B2B_LOG, {
        method: "POST", keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(charge)
      }).catch(function () {});
    } catch (e) { /* rien */ }
  }
  b2bLog("arrivee", (document.referrer || "").indexOf(location.host) >= 0 ? "interne" : "direct");

  function ajouter() {
    if (etat.envoi) return;
    if (!etat.lignes.length) {
      if (etat.cas === "catalogue") pickerOuvrir();
      else if (elInput) elInput.click();
      return;
    }
    var manquant = etat.lignes.some(function (l) { return !VARIANTES[l.format]; });
    if (manquant) {
      if (elEtat) elEtat.textContent = t("format_ko", "Un format choisi n'est plus disponible.");
      return;
    }

    /* ⛔ LE DELAI ET LA MARQUE BLANCHE SE POSENT SUR CHAQUE LIGNE, PAS UNE SEULE FOIS.
       L'atelier travaille ligne par ligne : le bon de production, le classement par delai et
       l'ecran Commandes lisent les proprietes de LA ligne qu'ils traitent. Une consigne posee
       sur la premiere affiche seulement disparaitrait des que le client supprime celle-la, ou
       des que l'atelier imprime les autres d'abord. */
    var communes = {};
    if (etat.delai !== "72h") communes._b2b_delai = etat.delai;
    if (etat.marqueBlanche) {
      communes._b2b_marque_blanche = "1";
      /* Le nom est facultatif : un revendeur peut vouloir un colis neutre SANS son nom
         dessus. Absent, le bon part sans expediteur, ce qui reste neutre. */
      if (etat.nomBlanc) communes._b2b_expediteur = etat.nomBlanc;
      /* ⚠️ L'URL VOYAGE, MAIS ELLE NE SERT PAS D'ADRESSE. Le serveur n'en retient que le NOM
         de fichier et le resout dans notre propre stockage : une valeur bricolee dans le
         panier ne designe rien. Voir `cleLogoDepuisUrl` cote serveur. */
      if (etat.logo) communes._b2b_logo = etat.logo;
    }

    var items = etat.lignes.map(function (l) {
      var props = { _b2b: "1" };
      Object.keys(communes).forEach(function (k) { props[k] = communes[k]; });
      if (l.type === "fichier") {
        props._perso_url = l.url;
        props._perso_preview = l.apercu || l.url;
        props.Fichier = l.nom;
        /* ⛔⛔ DEUX PROPRIETES, ET C'EST LA SECONDE QUI IMPRIME. `Orientation` est le libelle
           LISIBLE, celui que l'atelier voit sur la commande ; `_perso_orient` est celui que la
           chaine d'impression LIT (`routes.js` : `props._perso_orient === 'paysage'`). Je
           n'avais pose que le premier ce matin : un depot paysage partait alors dans une page
           PORTRAIT, avec le fichier couche au milieu et des bandes blanches en haut et en bas.
           La ligne etait juste a l'ecran et fausse a la sortie du traceur.
           ⚠️ ON RECOPIE LA CONVENTION DE LA PAGE PERSO, mot pour mot : `_perso_orient` porte
           toujours le sens, `Orientation` n'apparait qu'en paysage. Deux chemins qui alimentent
           le meme atelier doivent parler la meme langue, sinon l'un des deux se fait oublier. */
        if (l.orientation) {
          props._perso_orient = l.orientation === "paysage" ? "paysage" : "portrait";
          if (l.orientation === "paysage") props.Orientation = "Paysage";
        }
      } else {
        props._b2b_handle = l.handle;
        /* ⛔ LE HANDLE NE SUFFIT PAS A IMPRIMER (audit du 14/08/2026). Markets TRADUIT les
           handles : sur les douze marches non francais, `_b2b_handle` designe un produit que
           le serveur francais ne connait pas sous ce nom. `_b2b_produit` porte l'identifiant
           NUMERIQUE du produit choisi, le seul stable sur les treize marches : c'est LUI que
           le Studio lit pour retrouver le poster_id de l'oeuvre et monter le travail
           d'impression. Le handle reste pour l'affichage et le debug humain. */
        if (l.produitId) props._b2b_produit = String(l.produitId);
        props._perso_preview = l.apercu;
        props.Affiche = l.nom;
      }
      return { id: VARIANTES[l.format], quantity: Math.max(1, l.qte || 1), properties: props };
    });

    /* ⛔ UNE LIGNE DE SUPPLEMENT PAR FORMAT, A LA QUANTITE DES AFFICHES DE CE FORMAT. Un
       forfait unique aurait fait payer au 21x30 le temps machine du 70x100 ; et une seule
       ligne « urgence » de quantite 1 aurait facture le meme prix pour 5 affiches que pour
       250. Le supplement suit donc exactement ce qu'il accelere.
       ⚠️ CES LIGNES N'ENTRENT PAS DANS LE COMPTE DU DEGRESSIF : le produit « Production
       acceleree » est hors de la collection « Affiches professionnelles », sur laquelle les
       six remises automatiques sont calees. Elles ne peuvent donc ni faire franchir un
       palier, ni etre remisees. */
    if (etat.delai !== "72h") {
      var table = SUPPLEMENTS[etat.delai] || {};
      var parFormat = {};
      etat.lignes.forEach(function (l) {
        parFormat[l.format] = (parFormat[l.format] || 0) + Math.max(1, l.qte || 1);
      });
      Object.keys(parFormat).forEach(function (f) {
        var v = table[f];
        if (!v || !v.id) return;
        items.push({
          id: v.id,
          quantity: parFormat[f],
          properties: { _b2b: "1", _b2b_delai: etat.delai, Format: f }
        });
      });
    }

    etat.envoi = true;
    majBouton();
    if (elEtat) elEtat.textContent = "";

    /* ⚠️ LES UNITES SE COMPTENT SUR CE QUI PART AU PANIER, pas sur le nombre de lignes : un pro
       qui prend 250 A1 en une ligne pese 250, pas 1. C'est la mesure qu'Adrien a demandee. */
    var unitesAjoutees = items.reduce(function (n, it) { return n + (Number(it.quantity) || 0); }, 0);
    totalPanierB2B().then(function (m) {
      b2bLog("panier", etat.delai || "", unitesAjoutees, { montant: m });
    });
    /* ⛔ L'ATTRIBUT DE PANIER EST CE QUI RELIE LA VISITE A LA COMMANDE. Il remonte tel quel sur
       la commande et survit au passage en caisse ; c'est lui, et lui seul, qui permet au Studio
       de calculer un chiffre d'affaires sans jamais croire un POST du navigateur. */
    try {
      fetch(urlPanier("/cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { b2b_vid: b2bVid() } })
      }).catch(function () {});
    } catch (e) { /* rien */ }

    var ajout = window.murAddToCart
      ? window.murAddToCart({ items: items })
      : fetch(urlPanier("/cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); });

    ajout
      .then(function () {
        etat.envoi = false;
        etat.lignes = [];
        majLignes();
        majBouton();
        if (elEtat) elEtat.textContent = t("ajoute", "Ajouté au panier. La remise se recalcule sur le total.");
        return relirePanier();
      })
      .catch(function () {
        etat.envoi = false;
        majBouton();
        if (elEtat) elEtat.textContent = t("panier_ko", "L'ajout au panier a échoué, réessayez.");
      });
  }
  if (elAjouter) elAjouter.addEventListener("click", ajouter);
  if (elMobileCta) elMobileCta.addEventListener("click", ajouter);

  /* ===== Galerie ===== */

  /* ⛔ LA SCENE S'OUVRE EN GRAND AU CLIC (Adrien, serie 211 : « on doit pouvoir cliquer sur
     image pour l'ouvrir en grand »). La galerie montrait la machine et l'atelier dans une
     boite de 600 px : c'est une preuve, et une preuve qu'on ne peut pas regarder de pres ne
     prouve rien.

     ⛔⛔ L'ECOUTEUR EST SUR LE CONTENEUR, PAS SUR L'IMAGE. Changer de vignette REMPLACE
     l'element de scene (une video ne se pose pas dans un <img>, voir plus bas) : un ecouteur
     pose sur l'image d'origine partirait avec elle au premier changement, et le clic ne
     ferait plus rien sur toutes les vues suivantes. La delegation survit au remplacement.

     ⚠️ UNE VIDEO NE S'OUVRE PAS : elle a deja ses propres commandes, et l'agrandir n'apporte
     rien qu'un lecteur sans controle.

     ⚠️ ON REDEMANDE LA PLEINE LARGEUR AU CDN. La scene est servie en 1400 px, taille juste
     pour la page et insuffisante en plein ecran : `width=` est reecrit a 2400. Sur une URL
     qui n'est pas celle du CDN (un asset du theme), on garde la source telle quelle. */
  (function visionneuse() {
    var boite = document.querySelector(".b2b-gal__scene");
    if (!boite) return;

    function pleineTaille(src) {
      if (!src || src.indexOf("/cdn/") < 0) return src;
      return src.indexOf("width=") > -1
        ? src.replace(/([?&])width=\d+/, "$1width=2400")
        : src + (src.indexOf("?") < 0 ? "?" : "&") + "width=2400";
    }

    function ouvrir(src, alt) {
      var fond = document.createElement("div");
      fond.className = "b2bvue";
      var img = document.createElement("img");
      img.className = "b2bvue__img";
      img.src = pleineTaille(src);
      img.alt = alt || "";
      var x = document.createElement("button");
      x.type = "button";
      x.className = "b2bvue__x";
      x.setAttribute("aria-label", t("fermer", "Fermer"));
      x.textContent = "×";
      fond.appendChild(img);
      fond.appendChild(x);
      document.body.appendChild(fond);
      document.documentElement.classList.add("b2bcrop-ouvert");

      function fermer() {
        document.removeEventListener("keydown", auClavier);
        document.documentElement.classList.remove("b2bcrop-ouvert");
        if (fond.parentNode) fond.parentNode.removeChild(fond);
      }
      function auClavier(e) { if (e.key === "Escape") fermer(); }
      /* Le clic sur l'image elle-meme ne ferme pas : on vient justement de l'ouvrir pour
         la regarder, et un geste sur le sujet qui le fait disparaitre se lit comme une faute. */
      fond.addEventListener("click", function (e) { if (e.target !== img) fermer(); });
      document.addEventListener("keydown", auClavier);
      x.focus();
    }

    boite.addEventListener("click", function (e) {
      var cible = e.target;
      if (!cible || cible.tagName !== "IMG" || !cible.hasAttribute("data-b2b-scene")) return;
      ouvrir(cible.getAttribute("src"), cible.getAttribute("alt"));
    });
    boite.classList.add("est-agrandissable");
  })();


  var scene = $("[data-b2b-scene]");
  $$("[data-b2b-vignette]").forEach(function (b) {
    b.addEventListener("click", function () {
      $$("[data-b2b-vignette]").forEach(function (o) {
        o.setAttribute("aria-current", o === b ? "true" : "false");
      });
      if (!scene) return;
      /* ⛔ UNE VIDEO NE SE POSE PAS DANS UN <img> (Adrien, 13/08/2026 : la video de la fenetre
         qualite entre dans la galerie). Echanger le `src` d'une image pour un .mp4 ne leve
         aucune erreur : le navigateur affiche simplement une image cassee, et rien ne le dit.
         On REMPLACE donc l'element, et on garde le repere `data-b2b-scene` sur le nouveau. */
      var src = b.getAttribute("data-b2b-vignette");
      var alt = b.getAttribute("data-b2b-alt") || "";
      var veutVideo = b.getAttribute("data-b2b-video") === "1";
      var estVideo = scene.tagName === "VIDEO";
      if (veutVideo === estVideo) {
        scene.src = src;
        if (!veutVideo) scene.alt = alt;
        return;
      }
      var neuf = document.createElement(veutVideo ? "video" : "img");
      neuf.src = src;
      neuf.setAttribute("data-b2b-scene", "");
      if (veutVideo) {
        /* Muette et en boucle, comme dans la fenetre : elle montre un geste, elle ne parle pas.
           `playsinline` evite le plein ecran force sur iPhone. */
        neuf.muted = true; neuf.loop = true; neuf.autoplay = true;
        neuf.setAttribute("muted", ""); neuf.setAttribute("playsinline", "");
      } else {
        neuf.alt = alt;
      }
      scene.parentNode.replaceChild(neuf, scene);
      scene = neuf;
    });
  });

  /* ⛔ LES FLECHES CLIQUENT UNE VIGNETTE, ELLES NE POSENT PAS D'IMAGE (Adrien, serie 202).
     Tout le savoir de la galerie — video contre image, remplacement d'element, etat
     `aria-current` — vit dans l'ecouteur des vignettes juste au-dessus. Le dupliquer ici
     aurait donne deux verites sur la meme scene, et la video aurait casse a la premiere
     fleche.
     ⚠️ ON REPART DE LA LISTE A CHAQUE CLIC : la galerie ajoute des vignettes d'atelier apres
     celles du produit, et une liste capturee une fois vieillirait au premier changement. */
  (function flechesGalerie() {
    var prec = $("[data-b2b-prec]");
    var suiv = $("[data-b2b-suiv]");
    if (!prec || !suiv) return;
    function vignettes() { return $$("[data-b2b-vignette]"); }
    var n = vignettes().length;
    if (n < 2) return;
    prec.hidden = false;
    suiv.hidden = false;
    function bouger(pas) {
      var v = vignettes();
      if (!v.length) return;
      var i = 0;
      for (var k = 0; k < v.length; k++) {
        if (v[k].getAttribute("aria-current") === "true") { i = k; break; }
      }
      /* Le tour boucle : au bout, on revient au debut. Une fleche grisee en fin de liste
         demande de comprendre pourquoi elle ne repond pas. */
      var j = (i + pas + v.length) % v.length;
      v[j].click();
    }
    prec.addEventListener("click", function () { bouger(-1); });
    suiv.addEventListener("click", function () { bouger(1); });
  })();

  /* ===== Avis Junip : la note sous le titre, et le pied corrige ===== */

  /* ⛔ LA NOTE SOUS LE TITRE EST UNE COPIE DE CELLE DU BLOC D'AVIS, PAS UN SECOND CALCUL
     (Adrien, serie 191 : « ajoute les etoiles junip sous le titre »).
     Junip a bien un composant autonome — `junip-product-summary`, releve dans son bundle et
     non devine — mais il lit UN PRODUIT : `element.dataset.productId || ShopifyAnalytics.meta
     .product.id`. Sur cette page ce produit est « Affiche professionnelle », dont les avis
     propres ne sont pas ceux qu'on montre en bas : le bloc d'avis porte
     `data-reviews-type="all"` et tape `/v2/product_overview/reviews`, l'agregat de TOUTE la
     boutique. Deux sources differentes auraient donne « 4,8 · 5 avis » en bas et « 0 avis »
     en haut, sur la meme page.
     => ON RECOPIE LE RESUME DEJA RENDU. Il ne peut pas diverger de ce qu'il resume, et il ne
     coute aucun appel de plus.
     ⚠️ Junip rend son bloc APRES nous : d'ou l'observateur, borne a 15 s pour ne pas laisser
     un guetteur en vie sur une page ouverte toute la journee. */
  (function etoilesSousTitre() {
    var cible = document.querySelector("[data-b2b-etoiles]");
    var bloc = document.querySelector(".b2b-avis");
    if (!cible || !bloc) return;
    var pose = false;
    function essayer() {
      if (pose) return true;
      var moy = bloc.querySelector(".junip-product-review-average-container");
      if (!moy || !moy.textContent.trim()) return false;
      var copie = moy.cloneNode(true);
      /* La copie ne doit pas etre annoncee deux fois : le bloc du bas porte deja le detail. */
      copie.setAttribute("aria-hidden", "true");
      cible.appendChild(copie);
      cible.hidden = false;
      pose = true;
      return true;
    }
    if (essayer()) return;
    var obs = new MutationObserver(function () { if (essayer()) obs.disconnect(); });
    obs.observe(bloc, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  })();

  /* ⛔ « Avis publie le » N'EST PAS UNE DATE, C'EST UNE TRADUCTION RATEE (Adrien, serie 190).
     Junip signe son bloc par « Reviews powered by [logo] » ; la version francaise servie dit
     « Avis publie le » suivi du logo, ce qui se lit comme une date coupee. « Avis publie par »
     rend la phrase a son sens.
     ⚠️ ON NE TOUCHE QUE LA CHAINE FRANCAISE, ET EN ENTIER. Les douze autres marches recoivent
     leur propre traduction, qui n'a pas ce defaut : remplacer « le » par « par » a l'aveugle
     abimerait des phrases correctes. La table ci-dessous se lit comme un dictionnaire de
     corrections ; une langue absente n'est pas touchee. */
  (function corrigerPiedJunip() {
    /* ⚠️ PLURIEL (Adrien, serie 192) : la ligne signe TOUS les avis du bloc, pas un seul.

       ⛔⛔ ET ON SURVEILLE `document`, PAS `.b2b-avis` (Adrien, serie 202 : « il y a toujours
       "Avis publie le" dans la modale »). Junip rend sa fenetre d'avis AILLEURS dans la page,
       hors du bloc : mon observateur, accroche a `.b2b-avis`, ne la voyait jamais naitre, et
       toutes mes regles portees par ce parent l'ignoraient aussi.
       => UN OBSERVATEUR NE VOIT QUE SOUS SON NOEUD. Quand l'app tierce fabrique ses fenetres a
       la racine, c'est la racine qu'il faut regarder. Meme famille que « une regle rangee au
       bon endroit n'est pas une regle portee ».
       ⚠️ IL NE SE DECONNECTE PLUS AU PREMIER SUCCES : la modale se rouvre autant de fois que
       le lecteur clique, et chaque ouverture rend un pied neuf. Il vit 60 s, le temps qu'on
       lise les avis, puis il rend la main. */
    var corrections = { "Avis publié le": "Avis publiés par", "Avis publié par": "Avis publiés par" };
    function passer() {
      var pieds = document.querySelectorAll(".junip-powered-by-footer");
      Array.prototype.forEach.call(pieds, function (pied) {
        /* Seuls les noeuds de TEXTE : le logo est un enfant du meme element, et reecrire
           innerHTML l'effacerait. */
        Array.prototype.forEach.call(pied.childNodes, function (n) {
          if (n.nodeType !== 3) return;
          var t = n.nodeValue.trim();
          if (corrections[t]) n.nodeValue = n.nodeValue.replace(t, corrections[t]);
        });
      });
    }
    passer();
    var obs = new MutationObserver(passer);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 60000);
  })();

  /* ===== Le carrousel des paires avant / après =====
     ⚠️ LE RAIL DÉFILE TOUT SEUL, ce bloc n'ajoute que le confort. `scroll-snap` fait le
     feuilletage au doigt, à la molette et au clavier ; si ce script tombe, le carrousel reste
     utilisable, seuls les deux boutons et le compteur disparaissent de la logique.
     ⛔ LE COMPTEUR LIT LA POSITION, IL NE LA COMPTE PAS. Un compteur maison ment dès qu'on fait
     glisser au doigt sans toucher les boutons, et c'est le geste le plus fréquent sur mobile. */
  (function () {
    var boite = document.querySelector('[data-b2b-upc]');
    if (!boite) return;
    var rail = boite.querySelector('[data-b2b-upc-rail]');
    var cpt = boite.querySelector('[data-b2b-upc-cpt]');
    var prec = boite.querySelector('[data-b2b-upc-prec]');
    var suiv = boite.querySelector('[data-b2b-upc-suiv]');
    if (!rail || !rail.firstElementChild) return;
    var total = rail.children.length;

    function pas() {
      var st = getComputedStyle(rail);
      var g = parseFloat(st.columnGap || st.gap || '0') || 0;
      return rail.firstElementChild.getBoundingClientRect().width + g;
    }
    function rang() {
      var p = pas();
      return p > 0 ? Math.round(rail.scrollLeft / p) : 0;
    }
    function maj() {
      var i = Math.min(total - 1, Math.max(0, rang()));
      if (cpt) cpt.textContent = (i + 1) + ' / ' + total;
      if (prec) prec.disabled = i <= 0;
      if (suiv) suiv.disabled = i >= total - 1;
    }
    function pousser(d) {
      var i = Math.min(total - 1, Math.max(0, rang() + d));
      rail.scrollTo({ left: i * pas(), behavior: 'smooth' });
    }
    if (prec) prec.addEventListener('click', function () { pousser(-1); });
    if (suiv) suiv.addEventListener('click', function () { pousser(1); });

    var attente = false;
    rail.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () { attente = false; maj(); });
    }, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  })();

  /* ============================================================================================
   * LES VISUELS DEPOSES SURVIVENT A UN RECHARGEMENT.
   *
   * ⛔ CE QUI ETAIT PERDU N'ETAIT PAS LE FICHIER, C'ETAIT LA LISTE. Les octets partent chez nous
   * des le depot et vivent dans `perso_b2b/not_ordered/` pendant quatre-vingt-dix jours ; seule
   * `etat.lignes`, qui n'existait qu'en memoire, disparaissait au rechargement. Un acheteur qui
   * avait depose douze visuels, choisi douze formats et douze quantites devait TOUT refaire pour
   * un F5, un retour depuis un autre onglet, ou un telephone qui recharge la page en revenant
   * dessus. C'est le geste le plus couteux de la page, et c'etait celui qui ne resistait a rien.
   *
   * ⚠️ `sessionStorage` ET PAS `localStorage`. Ce sont les visuels d'un client, pas nos donnees :
   * ils appartiennent a la session en cours et partent avec l'onglet. Retrouver trois semaines
   * plus tard des fichiers qu'on croyait oublies serait une surprise desagreable, pas un service.
   *
   * ⛔ ET `src` NE SE SERIALISE PAS. C'est un objet `File`, une poignee vers le disque de
   * l'acheteur : rien ne la traverse un rechargement, aucun format de stockage ne la remplace.
   * Les lignes restaurees le declarent donc par `sansSource`, et `reformater` les protege.
   * ========================================================================================== */
  var CLE_LIGNES = "af:b2b:lignes";

  /* ⛔⛔ « HTTPS » NE PROUVE RIEN : C'EST L'HOTE QUI COMPTE. Un premier jet se contentait de
     verifier que l'adresse commencait par `https://`, ce qui laisse passer le monde entier.
     Le stockage de session est ecrit par le navigateur, donc modifiable a la main : une adresse
     libre ferait charger l'image de quelqu'un d'autre sur notre page, exactement la faute
     evitee sur les proprietes de ligne du panier.

     ⛔⛔ ET IL Y A DEUX ORIGINES LEGITIMES, PAS UNE. Deuxieme jet, mesure en production le
     21/08/2026 : borne au seul hote du service de depot, le controle rejetait EN SILENCE toutes
     les lignes du catalogue, dont l'apercu vit sur le CDN de la boutique. Trois affiches
     choisies, un rechargement, plus rien — et rien pour dire pourquoi. Une garde trop etroite ne
     protege pas mieux, elle casse ce qu'elle devait sauver, et elle le fait sans erreur.
     Les deux origines sont donc nommees : notre service de depot pour les fichiers deposes, la
     boutique et son CDN pour les visuels du catalogue. */
  function origineSure(u) {
    try {
      var a = new URL(String(u || ""), location.href);
      if (a.protocol !== "https:") return false;
      if (a.host === location.host) return true;
      if (/(^|\.)cdn\.shopify\.com$/.test(a.host)) return true;
      var n = new URL(CFG.upload, location.href);
      return a.host === n.host;
    } catch (e) { return false; }
  }
  /* L'adresse d'un fichier DEPOSE, elle, ne vient que de chez nous : le CDN de la boutique n'a
     aucune raison de porter un visuel d'acheteur, et l'y accepter ouvrirait une porte pour rien. */
  function chezNous(u) {
    try {
      var a = new URL(String(u || ""), location.href);
      if (a.protocol !== "https:") return false;
      var n = new URL(CFG.upload, location.href);
      return a.host === n.host;
    } catch (e) { return false; }
  }

  function sauverLignes() {
    try {
      var utiles = etat.lignes.map(function (l) {
        return {
          cle: l.cle, type: l.type, nom: l.nom, url: l.url, apercu: l.apercu,
          handle: l.handle, produitId: l.produitId,
          px: l.px, orientation: l.orientation, format: l.format, qte: l.qte,
          /* Une ligne relue n'aura jamais son fichier d'origine, meme si elle l'avait avant. */
          sansSource: true,
        };
      });
      if (!utiles.length) { sessionStorage.removeItem(CLE_LIGNES); return; }
      sessionStorage.setItem(CLE_LIGNES, JSON.stringify({ cas: etat.cas, lignes: utiles }));
    } catch (e) { /* quota plein ou stockage refuse : on ne casse pas la page pour autant */ }
  }

  function restaurerLignes() {
    var lu = null;
    try { lu = JSON.parse(sessionStorage.getItem(CLE_LIGNES) || "null"); } catch (e) { return; }
    if (!lu || !Array.isArray(lu.lignes) || !lu.lignes.length) return;
    /* ⛔ ON NE CROIT PAS CE QUI SORT DU STOCKAGE SUR PAROLE. Il est ecrit par le navigateur, donc
       modifiable a la main : une ligne sans type connu, ou dont l'adresse ne pointe pas chez
       nous, ferait charger l'image de quelqu'un d'autre sur notre page. Meme lecon que les
       proprietes de ligne du panier. */
    var propre = lu.lignes.filter(function (l) {
      if (!l || (l.type !== "fichier" && l.type !== "catalogue")) return false;
      if (l.type === "fichier" && !chezNous(l.url)) return false;
      if (l.apercu && !origineSure(l.apercu)) return false;
      return true;
    });
    if (!propre.length) return;
    var n = 0;
    etat.lignes = propre.map(function (l) {
      n += 1;
      return {
        cle: (l.type === "fichier" ? "f" : "c") + "r" + n,
        type: l.type, nom: String(l.nom || ""), url: l.url, apercu: l.apercu,
        handle: l.handle, produitId: l.produitId,
        px: l.px, orientation: l.orientation,
        format: l.format || etat.format,
        qte: Math.max(1, Number(l.qte) || 1),
        sansSource: true,
      };
    });
    if (lu.cas === "fichier" || lu.cas === "catalogue") poserCas(lu.cas);
  }

  /* ===== Démarrage ===== */

  /* ⛔ AVANT LE PREMIER `majLignes`, ET C'EST L'ORDRE QUI COMPTE : `majLignes` sauvegarde, donc
     un premier rendu a vide EFFACERAIT ce qu'on vient a peine de relire. */
  restaurerLignes();
  etat.formatGrille = etat.format;
  majOngletsGrille();
  majLignes();
  majBouton();
  majPrix();
  relirePanier();
})();
